<template>
  <div>
    <v-btn 
      v-if="showStickySaveButton" 
      color="success"
      size="large" 
      variant="elevated" 
      @click="Update" 
      :loading="dialog"
      :disabled="dialog" 
      class="save-action-button-small sticky-save-btn" 
      rounded="lg"
    >
      <v-img :src="images.saveImg" width="20" height="20" class="mr-2"></v-img>
      {{ $t("save") }} Changes
    </v-btn>
    <v-container fluid class="pa-6">
      <div class="sticky-tabs-container">
        <v-tabs v-model="selectedTab" class="platform-tabs sticky-tabs" grow hide-slider>
          <v-tab v-for="platform in platformConfig" :key="platform.key" :value="platform.key" class="platform-tab"
            :class="{ active: selectedTab === platform.key, [`tab-${platform.key}`]: true }">
            <div class="tab-inner">
              <div class="tab-icon-wrapper">
                <component :is="platform.icon" v-if="platform.icon === 'LineIcon'" :size="24" />
                <v-icon v-else :icon="platform.icon" size="24"></v-icon>

                <v-chip v-if="getConfigCount(platform.key) > 0" size="x-small" class="tab-chip" color="black"
                  variant="flat">
                  {{ getConfigCount(platform.key) }}
                </v-chip>
              </div>
              <span class="tab-label">{{ platform.name }}</span>
            </div>
          </v-tab>
        </v-tabs>
      </div>
      <!-- Header Section -->
      <!-- <div class="page-header" style="margin-bottom: 0px">
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("setup_title")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </div> -->
      <div class="config-grid">
        <div>
          <v-container fluid>
            <!-- Platform Selection Tabs -->
            <div class="platform-tabs-container">
              <!-- <v-tabs
                v-model="selectedTab"
                class="modern-tabs"
                color="primary"
                slider-color="primary"
                centered
                grow
              >
                <v-tab
                  v-for="platform in platformConfig"
                  :key="platform.key"
                  :value="platform.key"
                  class="platform-tab"
                  :class="`tab-${platform.key}`"
                >
                  <div class="tab-content">
                    <component
                      :is="platform.icon"
                      v-if="platform.icon === 'LineIcon'"
                      :size="24"
                      color="currentColor"
                    />
                    <v-icon v-else :icon="platform.icon" size="24"></v-icon>
                    <span class="tab-text">{{ platform.name }}</span>
                    <v-chip
                      v-if="getConfigCount(platform.key) > 0"
                      size="small"
                      :color="platform.chipColor"
                      variant="elevated"
                      class="config-count-chip"
                      :class="`chip-${platform.key}`"
                    >
                      <v-icon size="12" class="mr-1">mdi-circle-small</v-icon>
                      {{ getConfigCount(platform.key) }}
                    </v-chip>
                  </div>
                </v-tab>
              </v-tabs> -->

              <!-- Platform Content -->
              <v-window v-model="selectedTab" class="mt-6">
                <!-- LINE Tab -->
                <v-window-item value="line" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large line-gradient">
                        <LineIcon :size="32" color="white" />
                      </div>
                      <div class="platform-details">
                        <h2>LINE Messaging API</h2>
                        <p>
                          Connect your chatbot to LINE using your Channel Secret and Access Token.
                        </p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn 
                          color="success" 
                          variant="flat" 
                          size="default" 
                          @click="Add('line')"
                          class="compact-text-btn line-btn" 
                          rounded="lg"
                        >
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <!-- <span class="stat-number">{{
                            getConfigCount("line")
                          }}</span> -->
                          <span class="stat-label-1">Configurations: {{
                            getConfigCount("line")
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <v-row justify="end" class="mb-4 mr-2">
                      <v-btn color="success" size="large" variant="elevated" @click="Update" :loading="dialog"
                        :disabled="dialog" prepend-icon="mdi-content-save" class="save-action-button-small" rounded="lg"
                        style="margin-right: 12px">
                        <template v-slot:prepend>
                          <v-img :src="images.saveImg" width="20" height="20"></v-img>
                        </template>
                        {{ $t("save") }} Changes
                      </v-btn>
                      <v-btn color="success" variant="flat" size="default" @click="Add('line')" rounded="lg"
                        class="outlined-red-btn">
                        <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                        Add Configuration
                      </v-btn>
                    </v-row>

                    <!-- Configurations Grid -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div 
                        v-if="
                          setupList.filter((item) => item.activeFlag).length ===
                          0
                        " 
                        class="empty-state-card"
                      >
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2"
                            >mdi-chat-outline</v-icon
                          >
                        </div>
                        <h3>No LINE configurations yet</h3>
                        <p>
                          Create your first LINE bot configuration to get
                          started
                        </p>
                        <v-btn 
                          color="success" 
                          variant="elevated" 
                          size="large" 
                          @click="Add('line')" 
                          class="mt-4"
                        >
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else>
                        <v-expansion-panels variant="accordion" class="mb-4" multiple>
                          <v-expansion-panel v-for="(item, index) in setupList" :key="index" v-show="item.activeFlag"
                            :class="['accordion-custom', { 'accordion-open': expandedPanel === index }]"
                            @change="onExpandChange(index)">
                            <v-expansion-panel-title class="accordion-title">
                              <div class="d-flex align-center">
                                <img :src="images.gear" alt="addtotable" class="mr-1" style="width: 20px; height: 20px;" />
                                <span style="font-weight:600;" v-if="item.name">{{ item.name }}</span>
                                <span style="font-weight:600;" v-else>Config #{{ index + 1 }}</span>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn icon size="small" variant="text" @click.stop="Delete(item, index)"
                                class="delete-icon-btn">
                                <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px;" />
                              </v-btn>
                              <template #actions="{ expanded }">
                                <v-icon :icon="expanded ? 'mdi-menu-up' : 'mdi-menu-down'"
                                  color="#171717" size="32"></v-icon>
                              </template>
                            </v-expansion-panel-title>

                            <v-expansion-panel-text class="accordion-content">
                              <v-card flat class="accordion-inner-card">
                                <v-card-text>
                                  <!-- Basic Information -->
                                  <div class="section">
                                    <div class="section-header">
                                      <v-icon color="error" class="mr-1" size="20">mdi-information</v-icon>
                                      <span class="section-title-1">Basic Information</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Configuration Name <span style="color:red">*</span></span>
                                          <v-tooltip location="right" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props"
                                                class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>A label to identify this setup.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field v-model="item.name" :rules="[rules.required]"
                                          @keypress="specialCharacters($event)" @paste="specialCharactersOnPaste"
                                          variant="outlined" density="comfortable" hide-details="auto"
                                          class="modern-field mt-1" placeholder="Enter configuration name"
                                          color="primary">
                                        </v-text-field>
                                      </v-col>

                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Model Group</span>
                                          <v-tooltip location="right" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props"
                                                class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Select the model group linked to this LINE account.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-autocomplete :items="DDGroupModel" item-title="name" item-value="id"
                                          v-model="item.groupModelID" clearable variant="outlined" density="comfortable"
                                          hide-details="auto" class="modern-field mt-1" placeholder="Select group model"
                                          color="primary">
                                        </v-autocomplete>
                                      </v-col>
                                    </v-row>
                                  </div>

                                  <div class="action-divider"></div>


                                  <!-- Authentication Details -->
                                  <div class="section">
                                    <div class="section-header">
                                      <img :src="images.auth" alt="shieldkey" class="mr-1" style="width: 20px; height: 20px;" />
                                      <span class="section-title-1">Authentication Details</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="3" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Channel Secret <span style="color:red">*</span></span>
                                          <v-tooltip location="right" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props"
                                                class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Your LINE channel’s secret key.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field v-model="item.secret" :rules="[rules.required]" variant="outlined"
                                          density="comfortable" hide-details="auto" :type="checkSecretVisibility(
                                            'linecs:' + item.secret
                                          )
                                              ? 'text'
                                              : 'password'
                                            " class="modern-field secure-field mt-1" placeholder="Enter channel secret"
                                          color="primary">
                                          <template v-slot:append-inner>
                                            <v-btn icon variant="text" size="small" @click="
                                              toggleSecretVisibility(
                                                'linecs:' + item.secret,
                                                $event
                                              )
                                              ">
                                              <v-icon size="16">
                                                {{
                                                  checkSecretVisibility(
                                                    "linecs:" + item.secret
                                                  )
                                                    ? "mdi-eye"
                                                    : "mdi-eye-off"
                                                }}
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                        </v-text-field>
                                      </v-col>

                                      <v-col cols="3" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Channel Access Token <span style="color:red">*</span></span>
                                          <v-tooltip location="right" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props"
                                                class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Token used for authentication and messaging.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field v-model="item.token" :rules="[rules.required]" variant="outlined"
                                          density="comfortable" hide-details="auto" :type="checkSecretVisibility(
                                            'linetoken:' + item.token
                                          )
                                              ? 'text'
                                              : 'password'
                                            " class="modern-field secure-field mt-1" placeholder="Enter channel token"
                                          color="primary">
                                          <template v-slot:append-inner>
                                            <v-btn icon variant="text" size="small" @click="
                                              toggleSecretVisibility(
                                                'linetoken:' + item.token,
                                                $event
                                              )
                                              ">
                                              <v-icon size="16">
                                                {{
                                                  checkSecretVisibility(
                                                    "linetoken:" + item.token
                                                  )
                                                    ? "mdi-eye"
                                                    : "mdi-eye-off"
                                                }}
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                        </v-text-field>
                                      </v-col>
                                    </v-row>

                                    <v-row class="mt-4">
                                      <v-col cols="4">
                                        <v-card class="option-card d-flex flex-column"
                                          :class="{ 'option-active': item.emailVerification }"
                                          :style="item.emailVerification ? 'background: #FFF2F2;' : ''" flat
                                          height="100%" min-height="90px">
                                          <div class="d-flex justify-space-between align-start">
                                            <div class="option-header">
                                              <div class="d-flex align-center">
                                                <span style="font-weight: 600;">Require Email Verification</span>
                                                <v-tooltip top max-width="300">
                                                  <template v-slot:activator="{ props: attrs, on }">
                                                    <v-icon small color="grey lighten-1" v-bind="attrs" v-on="on"
                                                      class="ml-1">mdi-information-outline</v-icon>
                                                  </template>
                                                  <span>Limit access to this LINE integration by email. Users may be
                                                    required to validate their email before using the bot.</span>
                                                </v-tooltip>
                                              </div>
                                              <div class="grey--text text-caption mt-1">
                                                Users must verify their email before accessing the chatbot.
                                              </div>
                                            </div>
                                            <v-switch id="llm-selection-switch-modelmanagement"
                                              v-model="item.emailVerification" :class="[
                                                'publication-toggle',
                                                item.emailVerification
                                                  ? 'publication-toggle--active'
                                                  : 'publication-toggle--inactive'
                                              ]" color="primary" hide-details dense class="mt-0" inset></v-switch>
                                          </div>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                    <div v-if="item.emailVerification">
                                      <v-row>
                                        <!-- domain -->
                                        <v-col cols="6">
                                          <v-container class="allowed-domain-container pl-0 pr-0"
                                            style="max-width: 700px;">
                                            <!-- Top input chips area -->
                                            <v-row class="mb-2">
                                              <v-col>
                                                <div class="d-flex align-center">
                                                  <span>Allowed Domains</span>
                                                </div>
                                                <div class="allowed-domain-input-section d-flex align-center flex-wrap">
                                                  <v-combobox v-model="item.selectedDomains" color="#3859D0"
                                                    placeholder="example.com" chips multiple hide-details
                                                    variant="outlined" class="allowed-domain-combobox flex-grow-1 mr-4"
                                                    :class="{ 'customwidth': item.selectedDomains.length === 0, 'customwidth-expanded': item.selectedDomains.length > 0 }"
                                                    @update:model-value="validateDomains(item, $event)">
                                                    <!-- Custom chip -->
                                                    <template #chip="{ item: chipItem }">
                                                      <v-chip
                                                        :color="isValidDomain(chipItem.value) ? 'primary' : '#FFA726'"
                                                        variant="outlined" style="border-radius: 8px"
                                                        class="allowed-domain-chip" closable
                                                        @click:close="removeDomainChip(item, chipItem.value)">
                                                        {{ chipItem.value }}
                                                        <!-- <v-icon size="14" class="ml-1" v-if="!isValidDomain(chipItem.value)">mdi-alert-circle</v-icon> -->
                                                      </v-chip>
                                                    </template>

                                                    <!-- Append button -->
                                                    <template #append-inner>
                                                      <v-btn class="allowed-domain-insert-btn text-none" v-if="item.selectedDomains.length > 0"
                                                        style="border-radius: 16px; border: 1px solid #3859D0; background: #3859D0; color: white;"
                                                        @click="insertDomains(item)">
                                                        <img :src="images.addtable" alt="addtotable" class="mr-2" style="width: 20px; height: 20px;" />
                                                        Insert to Table
                                                      </v-btn>
                                                    </template>
                                                  </v-combobox>
                                                </div>
                                                <div v-if="item.showSuggestion" class="allowed-domain-suggestion">
                                                  Try something like “example.com”
                                                </div>
                                              </v-col>
                                            </v-row>
                                            <!-- Table header -->
                                            <div class="allowed-domain-header d-flex align-center mb-2">
                                              <v-icon color="error" class="mr-2">mdi-earth</v-icon>
                                              <span class="allowed-domain-title text-h6 font-weight-bold">
                                                Allowed Domains Table
                                              </span>
                                            </div>

                                            <!-- Search bar -->
                                            <div class="allowed-domain-search-bar d-flex align-center mb-2">
                                              <v-text-field v-model="item.searchDomains" placeholder="Search"
                                                hide-details variant="underlined"
                                                class="allowed-domain-search-field mr-2"><template v-slot:append-inner>
                                                  <v-icon size="20" color="error">mdi-magnify</v-icon>
                                                </template></v-text-field>
                                            </div>
                                            <div v-if="getFilteredDomains(item).length === 0 && item.domains && item.domains.length > 0 && item.searchDomains" class="nodatadiv">
                                                <span class="text-grey">Searching </span> " {{item.searchDomains}}" Domains was not found.
                                            </div>
                                            <!-- Domain table -->
                                            <v-table class="allowed-domain-table elevation-1">
                                              <thead>
                                                <tr>
                                                  <th class="allowed-domain-th text-left">No.</th>
                                                  <th class="allowed-domain-th text-left">Domain</th>
                                                  <th class="allowed-domain-th text-center">Manage</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <!-- No results message -->
                                                <!-- <tr
                                                  v-if="getFilteredDomains(item).length === 0 && item.domains && item.domains.length > 0">
                                                  <td colspan="3" class="allowed-domain-td text-center pa-4">
                                                    <span class="text-grey">No domains found for "{{ item.searchDomains
                                                      }}"</span>
                                                  </td>
                                                </tr> -->

                                                <tr v-for="(domain, index) in getFilteredDomains(item)" :key="index"
                                                  class="allowed-domain-tr">
                                                  <td class="allowed-domain-td">{{ index + 1 }}</td>
                                                  <td class="allowed-domain-td">{{ domain.contactValue || domain }}</td>
                                                  <td class="allowed-domain-td text-center">
                                                    <v-btn icon variant="text" color="primary"
                                                      class="allowed-domain-edit-btn"
                                                      @click="editDomain(item, getOriginalDomainIndex(item, index))">
                                                      <img :src="images.edit" alt="Edit"
                                                        style="width: 25px; height: 25px;" />
                                                      <v-tooltip activator="parent" location="top">
                                                        Edit
                                                      </v-tooltip>
                                                    </v-btn>
                                                    <v-btn icon variant="text" color="error"
                                                      class="allowed-domain-delete-btn"
                                                      @click="deleteDomain(item, getOriginalDomainIndex(item, index))">
                                                      <img :src="images.delete" alt="Delete"
                                                        style="width: 25px; height: 25px;" />
                                                      <v-tooltip activator="parent" location="top">
                                                        Delete
                                                      </v-tooltip>
                                                    </v-btn>
                                                  </td>
                                                </tr>
                                                <!-- Delete All Row - only show when there's data -->
                                                <tr v-if="getFilteredDomains(item).length > 0">
                                                  <td colspan="3" class="allowed-domain-td text-right pa-3">
                                                    <v-btn color="error" variant="outlined" rounded="lg" size="small"
                                                      class="text-none" @click="deleteAllDomains(item)">
                                                      Delete All
                                                    </v-btn>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </v-table>
                                          </v-container>
                                        </v-col>

                                        <!-- emails -->
                                        <v-col cols="6">
                                          <v-container class="allowed-domain-container pl-0 pr-0"
                                            style="max-width: 700px;">
                                            <!-- Top input chips area -->
                                            <v-row class="mb-2">
                                              <v-col>
                                                <div class="d-flex align-center">
                                                  <span>Allowed Emails</span>
                                                </div>
                                                <div class="allowed-domain-input-section d-flex align-center flex-wrap">
                                                  <v-combobox v-model="item.selectedEmails" placeholder="example@gmail.com"
                                                    chips multiple hide-details variant="outlined" color="#3859D0"
                                                    class="allowed-domain-combobox flex-grow-1 mr-4"
                                                    :class="{ 'customwidth': item.selectedEmails.length === 0, 'customwidth-expanded': item.selectedEmails.length > 0 }"
                                                    @update:model-value="validateEmails(item, $event)">
                                                    <!-- Custom chip -->
                                                    <template #chip="{ item: chipItem }">
                                                      <v-chip
                                                        :color="isValidEmail(chipItem.value) ? 'primary' : '#FFA726'"
                                                        variant="outlined" style="border-radius: 8px"
                                                        class="allowed-domain-chip" closable
                                                        @click:close="removeEmailChip(item, chipItem.value)">
                                                        {{ chipItem.value }}
                                                        <!-- <v-icon size="14" class="ml-1"
                                                          v-if="!isValidEmail(chipItem.value)">mdi-alert-circle</v-icon> -->
                                                      </v-chip>
                                                    </template>

                                                    <!-- Append button -->
                                                    <template #append-inner>
                                                      <v-btn class="allowed-domain-insert-btn text-none" v-if="item.selectedEmails.length > 0"
                                                        style="border-radius: 16px; border: 1px solid #3859D0; background: #3859D0; color: white;"
                                                        @click="insertEmails(item)">
                                                        <img :src="images.addtable" alt="addtotable" class="mr-2" style="width: 20px; height: 20px;" />
                                                        Insert to Table
                                                      </v-btn>
                                                    </template>
                                                  </v-combobox>

                                                </div>
                                                <div v-if="item.showEmailSuggestion" class="allowed-domain-suggestion">
                                                  Try something like “example@gmail.com”
                                                </div>
                                              </v-col>
                                            </v-row>
                                            <!-- Table header -->
                                            <div class="allowed-domain-header d-flex align-center mb-2">
                                              <img :src="images.email" alt="Mail" class="mr-2"
                                                style="width: 20px; height: 20px;" />
                                              <span class="allowed-domain-title text-h6 font-weight-bold">
                                                Allowed Emails Table
                                              </span>
                                            </div>

                                            <!-- Search bar -->
                                            <div class="allowed-domain-search-bar d-flex align-center mb-2">
                                              <v-text-field v-model="item.searchEmails" placeholder="Search"
                                                hide-details variant="underlined"
                                                class="allowed-domain-search-field mr-2"><template v-slot:append-inner>
                                                  <v-icon size="20" color="error">mdi-magnify</v-icon>
                                                </template></v-text-field>
                                            </div>
                                            <div  v-if="getFilteredEmails(item).length === 0 && item.emails && item.emails.length > 0 && item.searchEmails" class="nodatadiv">
                                                <span class="text-grey">Searching </span> " {{item.searchEmails}}" Email was not found.
                                            </div>
                                            <!-- Domain table -->
                                            <v-table class="allowed-domain-table elevation-1">
                                              <thead>
                                                <tr>
                                                  <th class="allowed-domain-th text-left">No.</th>
                                                  <th class="allowed-domain-th text-left">Email</th>
                                                  <th class="allowed-domain-th text-center">Manage</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <!-- No results message -->
                                                <!-- <tr
                                                  v-if="getFilteredEmails(item).length === 0 && item.emails && item.emails.length > 0">
                                                  <td colspan="3" class="allowed-domain-td text-center pa-4">
                                                    <span class="text-grey">No emails found for "{{ item.searchEmails
                                                      }}"</span>
                                                  </td>
                                                </tr> -->

                                                <tr v-for="(email, index) in getFilteredEmails(item)" :key="index"
                                                  class="allowed-domain-tr">
                                                  <td class="allowed-domain-td">{{ index + 1 }}</td>
                                                  <td class="allowed-domain-td">{{ email.contactValue || email }}</td>
                                                  <td class="allowed-domain-td text-center">
                                                    <v-btn icon variant="text" color="primary"
                                                      class="allowed-domain-edit-btn"
                                                      @click="editEmail(item, getOriginalEmailIndex(item, index))">
                                                      <img :src="images.edit" alt="Edit"
                                                        style="width: 25px; height: 25px;" />
                                                      <v-tooltip activator="parent" location="top">
                                                        Edit
                                                      </v-tooltip>
                                                    </v-btn>
                                                    <v-btn icon variant="text" color="error"
                                                      class="allowed-domain-delete-btn"
                                                      @click="deleteEmail(item, getOriginalEmailIndex(item, index))">
                                                      <img :src="images.delete" alt="Delete"
                                                        style="width: 25px; height: 25px;" />
                                                      <v-tooltip activator="parent" location="top">
                                                        Delete
                                                      </v-tooltip>
                                                    </v-btn>
                                                  </td>
                                                </tr>
                                                <!-- Delete All Row - only show when there's data -->
                                                <tr v-if="getFilteredEmails(item).length > 0">
                                                  <td colspan="3" class="allowed-domain-td text-right pa-3">
                                                    <v-btn color="error" variant="outlined" rounded="lg" size="small"
                                                      class="text-none" @click="deleteAllEmails(item)">
                                                      Delete All
                                                    </v-btn>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </v-table>
                                          </v-container>
                                        </v-col>
                                      </v-row>
                                    </div>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </v-expansion-panel-text>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>

                      <!-- <div class="config-cards-container">
                        <div
                          v-for="(item, index) in setupList"
                          :key="item.createDate.toString()"
                          v-show="item.activeFlag"
                          class="config-card line-card"
                        >
                          <div class="config-card-header">
                            <div class="config-badge">
                              <v-icon small class="mr-1">mdi-cog</v-icon>
                              Config #{{ index + 1 }}
                            </div>
                            <v-btn
                              icon
                              size="small"
                              variant="text"
                              @click="Delete(item, index)"
                              class="delete-icon-btn"
                            >
                              <v-icon color="error"
                                >mdi-trash-can-outline</v-icon
                              >
                            </v-btn>
                          </div>

                          <div class="config-card-body">
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="primary"
                                  >mdi-information</v-icon
                                >
                                Basic Information
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.name"
                                    label="Configuration Name"
                                    :rules="[rules.required]"
                                    @keypress="specialCharacters($event)"
                                    @paste="specialCharactersOnPaste"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Enter configuration name"
                                    color="primary"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="primary"
                                        >mdi-tag</v-icon
                                      >
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete
                                    :items="DDGroupModel"
                                    item-title="name"
                                    item-value="id"
                                    v-model="item.groupModelID"
                                    label="Group Model"
                                    clearable
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Select group model"
                                    color="primary"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="primary"
                                        >mdi-group</v-icon
                                      >
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="warning"
                                  >mdi-shield-key</v-icon
                                >
                                Authentication Details
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.secret"
                                    label="Channel Secret"
                                    :rules="[rules.required]"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    :type="
                                      checkSecretVisibility(
                                        'linecs:' + item.secret
                                      )
                                        ? 'text'
                                        : 'password'
                                    "
                                    class="modern-field secure-field"
                                    placeholder="Enter channel secret"
                                    color="primary"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="warning"
                                        >mdi-key-variant</v-icon
                                      >
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn
                                        icon
                                        variant="text"
                                        size="small"
                                        @click="
                                          toggleSecretVisibility(
                                            'linecs:' + item.secret,
                                            $event
                                          )
                                        "
                                      >
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "linecs:" + item.secret
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.token"
                                    label="Channel Token"
                                    :rules="[rules.required]"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    :type="
                                      checkSecretVisibility(
                                        'linetoken:' + item.token
                                      )
                                        ? 'text'
                                        : 'password'
                                    "
                                    class="modern-field secure-field"
                                    placeholder="Enter channel token"
                                    color="primary"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="info"
                                        >mdi-shield-key-outline</v-icon
                                      >
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn
                                        icon
                                        variant="text"
                                        size="small"
                                        @click="
                                          toggleSecretVisibility(
                                            'linetoken:' + item.token,
                                            $event
                                          )
                                        "
                                      >
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "linetoken:" + item.token
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                          </div>
                        </div>

                        <div class="add-config-card" @click="Add('line')">
                          <div class="add-card-content">
                            <v-icon size="48" color="success" class="mb-4"
                              >mdi-plus-circle</v-icon
                            >
                            <h4>Add New Configuration</h4>
                            <p>Create a new LINE bot configuration</p>
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </v-window-item>

                <!-- MS Teams Tab -->
                <v-window-item value="teams" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large teams-gradient">
                        <v-icon size="32" color="white"
                          >mdi-microsoft-teams</v-icon
                        >
                      </div>
                      <div class="platform-details">
                        <h2>Microsoft Teams</h2>
                        <p>Configure MS Teams</p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn 
                          color="purple" 
                          variant="flat" 
                          size="default" 
                          @click="Add('ms')"
                          class="compact-text-btn teams-btn" 
                          rounded="lg"
                        >
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-number">{{
                            getConfigCount("teams")
                          }}</span>
                          <span class="stat-label">Configurations</span>
                        </div>
                      </div>
                    </div>
                    <v-row justify="end" class="mb-4 mr-2">
                      <v-btn color="success" size="large" variant="elevated" @click="Update" :loading="dialog"
                        :disabled="dialog" prepend-icon="mdi-content-save" class="save-action-button-small"
                        rounded="lg">
                        <template v-slot:prepend>
                          <v-icon size="20">mdi-content-save</v-icon>
                        </template>
                        {{ $t("save") }} Changes
                      </v-btn>
                    </v-row>

                    <!-- Teams Configurations -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div
                        v-if="
                          setupListMS.filter((item) => item.activeFlag)
                            .length === 0
                        "
                        class="empty-state-card"
                      >
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2"
                            >mdi-microsoft-teams</v-icon
                          >
                        </div>
                        <h3>No Teams configurations yet</h3>
                        <p>
                          Create your first Microsoft Teams bot configuration
                        </p>
                        <v-btn
                          color="purple"
                          variant="elevated"
                          size="large"
                          @click="Add('ms')"
                          class="mt-4"
                        >
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else class="config-cards-container">
                        <!-- Teams Config Cards -->
                        <div
                          v-for="(item, index) in setupListMS"
                          :key="item.createDate.toString()"
                          v-show="item.activeFlag"
                          class="config-card teams-card"
                        >
                          <div class="config-card-header">
                            <div class="config-badge teams-badge">
                              <v-icon small class="mr-1">mdi-cog</v-icon>
                              Config #{{ index + 1 }}
                            </div>
                            <v-btn
                              icon
                              size="small"
                              variant="text"
                              @click="Delete(item, index)"
                              class="delete-icon-btn"
                            >
                              <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px;" />
                            </v-btn>
                          </div>

                          <div class="config-card-body">
                            <!-- Basic Information -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="purple"
                                  >mdi-information</v-icon
                                >
                                Basic Information
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.name"
                                    label="Configuration Name"
                                    :rules="[
                                      rules.required,
                                      (v) =>
                                        (v && v.length <= 100) ||
                                        'Max 100 characters',
                                    ]"
                                    @keypress="specialCharacters($event)"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Enter configuration name"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="purple"
                                        >mdi-tag</v-icon
                                      >
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete
                                    :items="DDGroupModel"
                                    item-title="name"
                                    item-value="id"
                                    v-model="item.groupModelID"
                                    label="Group Model"
                                    clearable
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Select group model"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="purple"
                                        >mdi-group</v-icon
                                      >
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Teams Configuration -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="purple"
                                  >mdi-microsoft-teams</v-icon
                                >
                                Teams Configuration
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-autocomplete
                                    :items="DDModelQuickGroup"
                                    item-title="name"
                                    item-value="id"
                                    v-model="item.modelQuickGroupID"
                                    label="Model Shortcut"
                                    clearable
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Select quick group model"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="purple"
                                        >mdi-lightning-bolt</v-icon
                                      >
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete
                                    :items="DDShortcuts"
                                    item-title="name"
                                    item-value="id"
                                    v-model="item.shortcutMenuGroupID"
                                    label="Shortcut Menu"
                                    clearable
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Select shortcut menu"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="purple"
                                        >mdi-menu</v-icon
                                      >
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Generated Link -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="info"
                                  >mdi-link-variant</v-icon
                                >
                                Generated Link
                              </h4>
                              <v-text-field
                                v-model="setupLinkMS[index]"
                                label="Integration Link"
                                variant="outlined"
                                density="comfortable"
                                readonly
                                hide-details="auto"
                                class="modern-field"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon size="20" color="info"
                                    >mdi-link</v-icon
                                  >
                                </template>
                                <template v-slot:append-inner>
                                  <v-btn
                                    icon
                                    variant="text"
                                    size="small"
                                    @click="ClipboardAPIKey(index)"
                                  >
                                    <v-icon size="16" color="purple"
                                      >mdi-content-copy</v-icon
                                    >
                                  </v-btn>
                                </template>
                              </v-text-field>
                            </div>
                          </div>
                        </div>

                        <div class="add-config-card" @click="Add('ms')">
                          <div class="add-card-content">
                            <v-icon size="48" color="purple" class="mb-4"
                              >mdi-plus-circle</v-icon
                            >
                            <h4>Add New Configuration</h4>
                            <p>Create a new Teams bot configuration</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-window-item>

                <!-- Facebook Tab -->
                <v-window-item value="facebook" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large facebook-gradient">
                        <v-icon size="32" color="white">mdi-facebook</v-icon>
                      </div>
                      <div class="platform-details">
                        <h2>Facebook Messenger</h2>
                        <p>Configure Facebook integration</p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn
                          color="blue"
                          variant="flat"
                          size="default"
                          @click="Add('facebook')"
                          class="compact-text-btn facebook-btn"
                          rounded="lg"
                        >
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-number">{{
                            getConfigCount("facebook")
                          }}</span>
                          <span class="stat-label">Configurations</span>
                        </div>
                      </div>
                    </div>
                    <v-row justify="end" class="mb-4 mr-2">
                      <v-btn color="success" size="large" variant="elevated" @click="Update" :loading="dialog"
                        :disabled="dialog" prepend-icon="mdi-content-save" class="save-action-button-small"
                        rounded="lg">
                        <template v-slot:prepend>
                          <v-icon size="20">mdi-content-save</v-icon>
                        </template>
                        {{ $t("save") }} Changes
                      </v-btn>
                    </v-row>

                    <!-- Facebook Configurations -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div
                        v-if="
                          setupListFacebook.filter((item) => item.activeFlag)
                            .length === 0
                        "
                        class="empty-state-card"
                      >
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2"
                            >mdi-facebook</v-icon
                          >
                        </div>
                        <h3>No Facebook configurations yet</h3>
                        <p>
                          Create your first Facebook Messenger bot configuration
                        </p>
                        <v-btn
                          color="blue"
                          variant="elevated"
                          size="large"
                          @click="Add('facebook')"
                          class="mt-4"
                        >
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else class="config-cards-container">
                        <div
                          v-for="(item, index) in setupListFacebook"
                          :key="item.createDate.toString()"
                          v-show="item.activeFlag"
                          class="config-card facebook-card"
                        >
                          <div class="config-card-header">
                            <div class="config-badge facebook-badge">
                              <v-icon small class="mr-1">mdi-cog</v-icon>
                              Config #{{ index + 1 }}
                            </div>
                            <v-btn
                              icon
                              size="small"
                              variant="text"
                              @click="Delete(item, index)"
                              class="delete-icon-btn"
                            >
                              <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px;" />
                            </v-btn>
                          </div>

                          <div class="config-card-body">
                            <!-- Basic Information -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="indigo"
                                  >mdi-information</v-icon
                                >
                                Basic Information
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.name"
                                    label="Configuration Name"
                                    :rules="[
                                      rules.required,
                                      (v) =>
                                        (v && v.length <= 100) ||
                                        'Max 100 characters',
                                    ]"
                                    @keypress="specialCharacters($event)"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Enter configuration name"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="indigo"
                                        >mdi-tag</v-icon
                                      >
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete
                                    :items="DDGroupModel"
                                    item-title="name"
                                    item-value="id"
                                    v-model="item.groupModelID"
                                    label="Group Model"
                                    clearable
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Select group model"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="indigo"
                                        >mdi-group</v-icon
                                      >
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Authentication Details -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="indigo"
                                  >mdi-shield-key</v-icon
                                >
                                Authentication Details
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.secret"
                                    label="Facebook Verify Token"
                                    :rules="[rules.required]"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    :type="
                                      checkSecretVisibility(
                                        'fbverify:' + item.secret
                                      )
                                        ? 'text'
                                        : 'password'
                                    "
                                    class="modern-field secure-field"
                                    placeholder="Enter verify token"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="indigo"
                                        >mdi-shield-check</v-icon
                                      >
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn
                                        icon
                                        variant="text"
                                        size="small"
                                        @click="
                                          toggleSecretVisibility(
                                            'fbverify:' + item.secret,
                                            $event
                                          )
                                        "
                                      >
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "fbverify:" + item.secret
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.token"
                                    label="Facebook Access Token"
                                    :rules="[rules.required]"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    :type="
                                      checkSecretVisibility(
                                        'fbtoken:' + item.token
                                      )
                                        ? 'text'
                                        : 'password'
                                    "
                                    class="modern-field secure-field"
                                    placeholder="Enter access token"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="indigo"
                                        >mdi-key</v-icon
                                      >
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn
                                        icon
                                        variant="text"
                                        size="small"
                                        @click="
                                          toggleSecretVisibility(
                                            'fbtoken:' + item.token,
                                            $event
                                          )
                                        "
                                      >
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "fbtoken:" + item.token
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- API Configuration -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="indigo"
                                  >mdi-api</v-icon
                                >
                                API Configuration
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.apI_Version"
                                    label="API Version"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Enter API version (e.g., v18.0)"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="indigo"
                                        >mdi-api</v-icon
                                      >
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.pageID"
                                    label="Page ID"
                                    :rules="[rules.required]"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Enter Facebook Page ID"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="indigo"
                                        >mdi-identifier</v-icon
                                      >
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                          </div>
                        </div>

                        <div class="add-config-card" @click="Add('facebook')">
                          <div class="add-card-content">
                            <v-icon size="48" color="blue" class="mb-4"
                              >mdi-plus-circle</v-icon
                            >
                            <h4>Add New Configuration</h4>
                            <p>Create a new Facebook bot configuration</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-window-item>

                <!-- Instagram Tab -->
                <v-window-item value="instagram" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large instagram-gradient">
                        <v-icon size="32" color="white">mdi-instagram</v-icon>
                      </div>
                      <div class="platform-details">
                        <h2>Instagram Messaging</h2>
                        <p>Configure Instagram for direct messages</p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn
                          color="pink"
                          variant="flat"
                          size="default"
                          @click="Add('instagram')"
                          class="compact-text-btn instagram-btn"
                          rounded="lg"
                        >
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-number">{{
                            getConfigCount("instagram")
                          }}</span>
                          <span class="stat-label">Configurations</span>
                        </div>
                      </div>
                    </div>
                    <v-row justify="end" class="mb-4 mr-2">
                      <v-btn color="success" size="large" variant="elevated" @click="Update" :loading="dialog"
                        :disabled="dialog" prepend-icon="mdi-content-save" class="save-action-button-small"
                        rounded="lg">
                        <template v-slot:prepend>
                          <v-icon size="20">mdi-content-save</v-icon>
                        </template>
                        {{ $t("save") }} Changes
                      </v-btn>
                    </v-row>

                    <!-- Instagram Configurations -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div
                        v-if="
                          setupListInstagram.filter((item) => item.activeFlag)
                            .length === 0
                        "
                        class="empty-state-card"
                      >
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2"
                            >mdi-instagram</v-icon
                          >
                        </div>
                        <h3>No Instagram configurations yet</h3>
                        <p>
                          Create your first Instagram messaging bot
                          configuration
                        </p>
                        <v-btn
                          color="pink"
                          variant="elevated"
                          size="large"
                          @click="Add('instagram')"
                          class="mt-4"
                        >
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else class="config-cards-container">
                        <div
                          v-for="(item, index) in setupListInstagram"
                          :key="item.createDate.toString()"
                          v-show="item.activeFlag"
                          class="config-card instagram-card"
                        >
                          <div class="config-card-header">
                            <div class="config-badge instagram-badge">
                              <v-icon small class="mr-1">mdi-cog</v-icon>
                              Config #{{ index + 1 }}
                            </div>
                            <v-btn
                              icon
                              size="small"
                              variant="text"
                              @click="Delete(item, index)"
                              class="delete-icon-btn"
                            >
                              <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px;" />
                            </v-btn>
                          </div>

                          <div class="config-card-body">
                            <!-- Basic Information -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="pink"
                                  >mdi-information</v-icon
                                >
                                Basic Information
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.name"
                                    label="Configuration Name"
                                    :rules="[
                                      rules.required,
                                      (v) =>
                                        (v && v.length <= 100) ||
                                        'Max 100 characters',
                                    ]"
                                    @keypress="specialCharacters($event)"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Enter configuration name"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="pink"
                                        >mdi-tag</v-icon
                                      >
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete
                                    :items="DDGroupModel"
                                    item-title="name"
                                    item-value="id"
                                    v-model="item.groupModelID"
                                    label="Group Model"
                                    clearable
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Select group model"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="pink"
                                        >mdi-group</v-icon
                                      >
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Authentication Details -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="pink"
                                  >mdi-shield-key</v-icon
                                >
                                Authentication Details
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.secret"
                                    label="Instagram Verify Token"
                                    :rules="[rules.required]"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    :type="
                                      checkSecretVisibility(
                                        'igverify:' + item.secret
                                      )
                                        ? 'text'
                                        : 'password'
                                    "
                                    class="modern-field secure-field"
                                    placeholder="Enter verify token"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="pink"
                                        >mdi-shield-check</v-icon
                                      >
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn
                                        icon
                                        variant="text"
                                        size="small"
                                        @click="
                                          toggleSecretVisibility(
                                            'igverify:' + item.secret,
                                            $event
                                          )
                                        "
                                      >
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "igverify:" + item.secret
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.token"
                                    label="Instagram Access Token"
                                    :rules="[rules.required]"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    :type="
                                      checkSecretVisibility(
                                        'igtoken:' + item.token
                                      )
                                        ? 'text'
                                        : 'password'
                                    "
                                    class="modern-field secure-field"
                                    placeholder="Enter access token"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="pink"
                                        >mdi-key</v-icon
                                      >
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn
                                        icon
                                        variant="text"
                                        size="small"
                                        @click="
                                          toggleSecretVisibility(
                                            'igtoken:' + item.token,
                                            $event
                                          )
                                        "
                                      >
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "igtoken:" + item.token
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- API Configuration -->
                            <div class="form-section">
                              <h4 class="section-title">
                                 <v-icon small class="mr-2" color="pink"
                                  >mdi-api</v-icon
                                >
                                API Configuration
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.apI_Version"
                                    label="API Version"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Enter API version (e.g., v18.0)"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="pink"
                                        >mdi-api</v-icon
                                      >
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.pageID"
                                    label="Page ID"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Enter Instagram Page ID"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="pink"
                                        >mdi-identifier</v-icon
                                      >
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                          </div>
                        </div>

                        <div class="add-config-card" @click="Add('instagram')">
                          <div class="add-card-content">
                            <v-icon size="48" color="pink" class="mb-4"
                              >mdi-plus-circle</v-icon
                            >
                            <h4>Add New Configuration</h4>
                            <p>Create a new Instagram bot configuration</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-window-item>

                <!-- Snippet Tab -->
                <v-window-item value="snippet" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large snippet-gradient">
                        <v-icon size="32" color="white">mdi-code-tags</v-icon>
                      </div>
                      <div class="platform-details">
                        <h2>Web Snippet Integration</h2>
                        <p>
                          Configure web snippet for website chatbot integration
                        </p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn
                          color="orange"
                          variant="flat"
                          size="default"
                          @click="Add('snippet')"
                          class="compact-text-btn snippet-btn"
                          rounded="lg"
                        >
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-number">{{
                            getConfigCount("snippet")
                          }}</span>
                          <span class="stat-label">Configurations</span>
                        </div>
                      </div>
                    </div>
                    <v-row justify="end" class="mb-4 mr-2">
                      <v-btn color="success" size="large" variant="elevated" @click="Update" :loading="dialog"
                        :disabled="dialog" prepend-icon="mdi-content-save" class="save-action-button-small"
                        rounded="lg">
                        <template v-slot:prepend>
                          <v-icon size="20">mdi-content-save</v-icon>
                        </template>
                        {{ $t("save") }} Changes
                      </v-btn>
                    </v-row>

                    <!-- Snippet Configurations -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div
                        v-if="
                          setupListSnippet.filter((item) => item.activeFlag)
                            .length === 0
                        "
                        class="empty-state-card"
                      >
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2"
                            >mdi-code-tags</v-icon
                          >
                        </div>
                        <h3>No Snippet configurations yet</h3>
                        <p>Create your first web snippet configuration</p>
                        <v-btn
                          color="orange"
                          variant="elevated"
                          size="large"
                          @click="Add('snippet')"
                          class="mt-4"
                        >
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else class="config-cards-container">
                         <div
                          v-for="(item, index) in setupListSnippet"
                          :key="item.createDate.toString()"
                          v-show="item.activeFlag"
                          class="config-card snippet-card"
                        >
                          <div class="config-card-header">
                            <div class="config-badge snippet-badge">
                              <v-icon small class="mr-1">mdi-cog</v-icon>
                              Config #{{ index + 1 }}
                            </div>
                            <v-btn
                              icon
                              size="small"
                              variant="text"
                              @click="Delete(item, index)"
                              class="delete-icon-btn"
                            >
                              <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px;" />
                            </v-btn>
                          </div>

                          <div class="config-card-body">
                            <!-- Basic Information -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="orange"
                                  >mdi-web-box</v-icon
                                >
                                Basic Information
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.name"
                                    label="Domain Name"
                                    :rules="[
                                      rules.required,
                                      (v) =>
                                        (v && v.length <= 100) ||
                                        'Max 100 characters',
                                    ]"
                                    @keypress="specialCharactersDomain($event)"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Enter domain name"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="orange"
                                        >mdi-web</v-icon
                                      >
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete
                                    :items="listDDModel"
                                    item-title="name"
                                    item-value="modelDisplayID"
                                    v-model="item.modelDisplayID"
                                    label="Model Display"
                                    required
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Select model display"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="orange"
                                        >mdi-brain</v-icon
                                      >
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Configuration Details -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="orange"
                                  >mdi-cog-outline</v-icon
                                >
                                Configuration Details
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.token"
                                    label="Token"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Enter token (optional)"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="orange"
                                        >mdi-key</v-icon
                                      >
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.lineUserID"
                                    label="User Default"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Enter default user ID"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="orange"
                                        >mdi-account</v-icon
                                      >
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Generated Resources -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="info"
                                  >mdi-link-variant</v-icon
                                >
                                Generated Resources
                              </h4>
                              <v-text-field
                                v-model="item.link"
                                label="Integration Link"
                                variant="outlined"
                                density="comfortable"
                                readonly
                                hide-details="auto"
                                class="modern-field"
                                placeholder="Generated integration link"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon size="20" color="info"
                                    >mdi-link</v-icon
                                  >
                                </template>
                                <template v-slot:append-inner>
                                  <v-btn 
                                    icon 
                                    variant="text" 
                                    size="small" 
                                    @click="ClipboardScriptSnippet(index)"
                                  >
                                    <v-icon size="16" color="orange"
                                      >mdi-content-copy</v-icon
                                    >
                                  </v-btn>
                                </template>
                              </v-text-field>
                            </div>
                          </div>
                        </div>

                        <div class="add-config-card" @click="Add('snippet')">
                          <div class="add-card-content">
                            <v-icon size="48" color="orange" class="mb-4"
                              >mdi-plus-circle</v-icon
                            >
                            <h4>Add New Configuration</h4>
                            <p>Create a new Snippet configuration</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-window-item>
              </v-window>
            </div>
          </v-container>
        </div>
      </div>
    </v-container>

    <!-- Loading Overlay -->
    <v-overlay :value="dialog" color="primary" opacity="0.8">
      <div class="text-center">
        <v-progress-circular 
          indeterminate 
          size="64" 
          color="white" 
          width="4"
        ></v-progress-circular>
        <p class="white--text mt-4 subtitle-1">Loading...</p>
      </div>
    </v-overlay>

    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title" v-if="deleteType === 'domain'">Delete Domain</span>
          <span class="delete-dialog-title" v-else-if="deleteType === 'email'">Delete Email</span>
          <span class="delete-dialog-title" v-else-if="deleteType === 'domain-all'">Delete All Domains</span>
          <span class="delete-dialog-title" v-else-if="deleteType === 'email-all'">Delete All Emails</span>
          <span class="delete-dialog-title" v-else>Delete</span>
          <v-btn icon variant="text" size="small" class="delete-close-icon" @click="cancelDelete">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteType === 'domain'">
            Are you sure you want to delete this domain? This action cannot be undone.
          </span>
          <span v-else-if="deleteType === 'email'">
            Are you sure you want to delete this email? This action cannot be undone.
          </span>
          <span v-else-if="deleteType === 'domain-all'">
            Are you sure you want to delete all domains from the list? This action cannot be undone.
          </span>
          <span v-else-if="deleteType === 'email-all'">
            Are you sure you want to delete all emails from the list? This action cannot be undone.
          </span>
          <span v-else>
            Are you sure you want to delete this item? This action cannot be undone.
          </span>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn class="delete-cancel-btn" @click="cancelDelete">
            Cancel
          </v-btn>
          <v-btn class="delete-confirm-btn" @click="confirmDelete">
            <v-icon left size="18">mdi-trash-can-outline</v-icon>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_delete_Config" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Delete</span>
          <v-btn icon variant="text" size="small" class="delete-close-icon" @click="cancelDelete">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span>
            Are you sure you want to delete this item? This action cannot be undone.
          </span>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn class="delete-cancel-btn" @click="cancelDeleteConfig">
            Cancel
          </v-btn>
          <v-btn class="delete-confirm-btn" @click="confirmDeleteConfig">
            <v-icon left size="18">mdi-trash-can-outline</v-icon>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Custom Edit Dialog -->
    <v-dialog v-model="dialog_edit" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Edit {{ editType === 'domain' ? 'Domain' : 'Email' }}</span>
          <v-btn icon variant="text" size="small" class="delete-close-icon" @click="cancelEdit">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <!-- Domain Input Field -->
          <v-text-field v-if="editType === 'domain'" v-model="editValue" label="Domain"
            placeholder="Enter domain (e.g., example.com)" :rules="[rules.required, validateDomainRule]"
            variant="outlined" density="comfortable" hide-details="auto" class="modern-field" color="primary"
            @keydown.enter="confirmEdit">
            <template v-slot:prepend-inner>
              <v-icon size="20" color="error">mdi-earth</v-icon>
            </template>
          </v-text-field>

          <!-- Email Input Field -->
          <v-text-field v-if="editType === 'email'" v-model="editValue" label="Email"
            placeholder="Enter email (e.g., user@example.com)" :rules="[rules.required, validateEmailRule]"
            variant="outlined" density="comfortable" hide-details="auto" class="modern-field" color="primary"
            @keydown.enter="confirmEdit">
            <template v-slot:prepend-inner>
              <v-icon size="20" color="primary">mdi-email</v-icon>
            </template>
          </v-text-field>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn class="delete-cancel-btn" @click="cancelEdit">
            Cancel
          </v-btn>
          <v-btn class="delete-confirm-btn" @click="confirmEdit" :disabled="!isEditValueValid">
            <v-icon left size="18">mdi-content-save</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import LineIcon from "@/components/icons/LineIcon.vue";
// import checkPermissionFour from "@/api/function.js";
import LogTrace from "@/api/function.js";
import { mask } from "vue-the-mask";
import editImg from "@/assets/Icons/Edit.png";
import deleteImg from "@/assets/Icons/Delete.png";
import AuthImg from "@/assets/Icons/AuthShield.png";
import EarthImg from "@/assets/Icons/EarthDomain.png";
import EmailImg from "@/assets/Icons/EmailTable.png";
import Addtable from "@/assets/Icons/AddTable.svg";
import Gear from "@/assets/Icons/ConfigGear.svg";
import saveImg from "@/assets/Icons/savecard.png";
export default {
  name: "SetupSocial",
  inject: ["flagNav", "FontColorTitle", "SubNavbarBackGround"],
  mixins: [LogTrace],
  components: {
    LineIcon,
  },
  directives: {
    mask,
  },
  data: () => ({
    mask: "##########",
    showStickySaveButton: false,
    scrollThreshold: 300,
    selectedTab: "line",
    platformConfig: [
      {
        key: "line",
        name: "LINE",
        icon: "LineIcon",
        chipColor: "success",
        gradient: "line-gradient",
      },
      {
        key: "teams",
        name: "Teams",
        icon: "mdi-microsoft-teams",
        chipColor: "purple",
        gradient: "teams-gradient",
      },
      {
        key: "facebook",
        name: "Facebook",
        icon: "mdi-facebook",
        chipColor: "blue",
        gradient: "facebook-gradient",
      },
      {
        key: "instagram",
        name: "Instagram",
        icon: "mdi-instagram",
        chipColor: "pink",
        gradient: "instagram-gradient",
      },
      {
        key: "snippet",
        name: "Snippet",
        icon: "mdi-code-tags",
        chipColor: "orange",
        gradient: "snippet-gradient",
      },
    ],
    headers: [],
    items: [],
    panel: [0],
    show1: false,
    formHasErrors: false,
    showSecretKey: [],
    expandedPlatforms: {
      line: true,
      teams: false,
      facebook: false,
      instagram: false,
      snippet: false,
    },
    permission: {
      add: true,
      edit: true,
      delete: true,
    },
    mailcheck: false,
    phonecheck: false,
    chkDataLine: false,

    DDModelQuickGroup: [],

    DDGroupModel: [],
    DDShortcuts: [],
    numberRules: [(v) => !!v || "Input is required!"],
    rules: {
      required: (value) => !!value || "Required.",
    },
    Email: null,
    gg: null,
    UserType: null,
    dialog: false,
    edit: {
      id: null,
      key: null,
      value: null,
    },
    user: {
      id: null,
      key: null,
      value: null,
    },

    Editdialog: false,
    Adddialog: false,
    isSearch: false,
    searchname: "",
    email: "",
    totalTable: 0,
    itemsPerPage: 10,
    options: {},
    today: null,
    setupListGeneral: [],
    setupGeneral: {
      azureOpenAI_URL: null,
      azureOpenAI_APIKey: null,
      azureStorageConnection: null,
      azureContainer: null,
      languageTranslatorKey: null,
      languageTranslatorLocation: null,
      languageKey: null,
      languageEndpoint: null,
      channelSecretInternal: null,
      channelTokenInternal: null,
      emailHost: null,
      hostName: null,
      password: null,
      openAIAPIKey: null,
      openAIUrl: null,
      speechToTextKey: null,
      speechToTextRegion: null,
      speechToTextLanguage: null,
      pathFFMpeg: null,
      pathFFMpegLocal: null,
      autoStream: null,
    },
    setupList: [],
    setupListMS: [],
    setupListSnippet: [],
    setupListFacebook: [],
    setupListInstagram: [],
    setupLinkMS: [],
    setup: {
      azureOpenAI_URL: null,
      azureOpenAI_APIKey: null,
      azureStorageConnection: null,
      azureContainer: null,
      languageTranslatorKey: null,
      languageTranslatorLocation: null,
      languageKey: null,
      languageEndpoint: null,
      channelSecretInternal: null,
      channelTokenInternal: null,
      emailHost: null,
      hostName: null,
      password: null,
      openAIAPIKey: null,
      openAIUrl: null,
    },
    secretKey: "01234567890123456789012345678901",
    specialCharacter: /[!@#$%^&*(),.?":{}|<>+`~ ]/,
    specialCharacterDomain: /[!@#$%^&*(),?":{}|<>+`~ ]/,
    images: {
      edit: editImg,
      delete: deleteImg,
      auth: AuthImg,
      earth: EarthImg,
      email: EmailImg,
      addtable: Addtable,
      gear: Gear,
      saveImg: saveImg,
    },
    listDDModel: [],
    showSuggestion: false,
    search: "",
    expandedPanel: null,
    dialog_delete: false,
    dialog_delete_Config: false,
    deleteItem: null,
    deleteType: '', // 'domain', 'email', 'domain-all', 'email-all'
    deleteIndex: -1,
    currentEditingItem: null,
    // Edit dialog properties
    dialog_edit: false,
    editItem: null,
    editType: '', // 'domain', 'email'
    editIndex: -1,
    editValue: '',
    currentEditingConfig: null,
  }),
  watch: {},
  mounted() {
    this.GetDate();
    this.Get();
    this.GetModel();

    const scroller = document.querySelector(".v-main__scroller") || window;
    scroller.addEventListener("scroll", this.handleScroll, true);
    this._scrollContainer = scroller;
  },
  unmounted() {
    // ลบ listener ออกจาก container ที่แท้จริง
    if (this._scrollContainer) {
      this._scrollContainer.removeEventListener(
        "scroll",
        this.handleScroll,
        true
      );
    }
  },
  computed: {
    form() {
      return {
        id: this.user.id,
        key: this.user.key,
        value: this.user.value,
      };
    },

    isEditValueValid() {
      if (!this.editValue.trim()) return false;

      if (this.editType === 'domain') {
        return this.isValidDomain(this.editValue.trim());
      } else if (this.editType === 'email') {
        return this.isValidEmail(this.editValue.trim());
      }

      return false;
    },

    validateDomainRule() {
      return (value) => {
        if (!value) return 'Domain is required';
        return this.isValidDomain(value) || 'Please enter a valid domain (e.g., example.com)';
      };
    },

    validateEmailRule() {
      return (value) => {
        if (!value) return 'Email is required';
        return this.isValidEmail(value) || 'Please enter a valid email address';
      };
    },
  },

  methods: {
    handleScroll(event) {
      const openAutocomplete = document.querySelector(
        ".v-overlay--active .v-list"
      );
      if (openAutocomplete) {
        return;
      }
      const target = event.target;
      if (target.closest('.v-navigation-drawer') ||
        target.closest('.v-app-bar') ||
        target.closest('.v-toolbar')) {
        return;
      }
      const { scrollTop } = event.target;
      if (scrollTop >= this.scrollThreshold) {
        this.showStickySaveButton = true;
      } else {
        this.showStickySaveButton = false;
      }
    },
    toggleSecretVisibility(key, event) {
      event.preventDefault();
      event.stopPropagation();
      const inputElement = event.target
        .closest(".v-field")
        .querySelector("input");
      if (inputElement) {
        inputElement.blur();
      }

      if (this.showSecretKey.includes(key)) {
        this.showSecretKey.splice(this.showSecretKey.indexOf(key), 1);
      } else {
        this.showSecretKey.push(key);
      }
    },
    checkSecretVisibility(key) {
      return this.showSecretKey.includes(key);
    },
    toggleExpansion(platform) {
      this.expandedPlatforms[platform] = !this.expandedPlatforms[platform];
    },
    getConfigCount(platform) {
      switch (platform) {
        case "line":
          return this.setupList.filter((item) => item.activeFlag).length;
        case "teams":
          return this.setupListMS.filter((item) => item.activeFlag).length;
        case "facebook":
          return this.setupListFacebook.filter((item) => item.activeFlag)
            .length;
        case "instagram":
          return this.setupListInstagram.filter((item) => item.activeFlag)
            .length;
        case "snippet":
          return this.setupListSnippet.filter((item) => item.activeFlag).length;
        default:
          return 0;
      }
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    Get() {
      try {
        let self = this;
        self.dialog = true;
        self.$call.GetOverviewSocial(
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let data = dataResponse.data;
               // DEBUG: Log the raw data to see what's returned

              self.setupList = data.filter((e) => e.typeSocial == "line");
              self.setupListMS = data.filter((e) => e.typeSocial == "ms");
              self.setupListSnippet = data.filter(
                (e) => e.typeSocial == "snippet"
              );
              self.setupListFacebook = data.filter(
                (e) => e.typeSocial == "facebook"
              );
              self.setupListInstagram = data.filter(
                (e) => e.typeSocial == "instagram"
              );
              self.setupLinkMS = [];
              self.setupListMS.forEach((element) => {
                var temp = element.name.split("`");
                element.name = temp[0];
                self.setupLinkMS.push(temp[1]);
              });
              self.setupListSnippet.map((el) => {
                let temp = el.name.split("`");
                el.name = temp[0];
                el.link = temp[1];
                return {
                  ...el,
                };
              });

              // Process verified contacts for domains and emails on each split array
              self.processVerifiedContacts(self.setupList);
              self.processVerifiedContacts(self.setupListMS);
              self.processVerifiedContacts(self.setupListSnippet);
              self.processVerifiedContacts(self.setupListFacebook);
              self.processVerifiedContacts(self.setupListInstagram);
            }
            self.dialog = false;
            self.isSearch = false;
            self.chkDataLine = true;
            self.GetDDGroupModel();
            self.GetDDShortcutMenu();
            self.GetDDModelQuickGroup();
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            self.chkDataLine = true;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    GetGeneral() {
      try {
        let self = this;
        self.$call.GetSetupOverview(
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.setupListGeneral = dataResponse.data;
              self.MapSetupList(self.setupListGeneral, false);
            }
            self.dialog = false;
            self.isSearch = false;
            self.Get();
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    GetDDGroupModel() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDGroupModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGroupModel = dataResponse.data;
          } else {
            self.DDGroupModel = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDDShortcutMenu() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDShortcutMenu(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDShortcuts = dataResponse.data;
          } else {
            self.DDShortcuts = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDDModelQuickGroup() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDModelQuickGroup(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDModelQuickGroup = dataResponse.data;
          } else {
            self.DDModelQuickGroup = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    MapSetupList(source, mapForSave) {
      let self = this;
      source.forEach((element) => {
        switch (element.key) {
          case "ChannelSecret_Internal":
            element.value = mapForSave
              ? self.setupGeneral.channelSecretInternal
              : element.value;
            self.setupGeneral.channelSecretInternal = element.value;
            break;
          case "ChannelToken_Internal":
            element.value = mapForSave
              ? self.setupGeneral.channelTokenInternal
              : element.value;
            self.setupGeneral.channelTokenInternal = element.value;
            break;

          default:
            break;
        }
      });
    },
    EditUser(temp) {
      let self = this;
      self.edit.id = temp.id;
      self.edit.key = temp.key;
      self.edit.value = temp.value;

      self.Editdialog = true;
    },
    validateNameLength() {
      let self = this;
      const lists = [
        self.setupList,
        self.setupListMS,
        self.setupListSnippet,
        self.setupListFacebook,
        self.setupListInstagram,
      ];
      for (const list of lists) {
        for (const item of list) {
          if (item.name && item.name.length > 100) {
            return false;
          }
        }
      }
      return true;
    },    
      // Separate basic field validation from email verification validation
      ValidateBasicFields(data) {
        for (const element of data) {
          let temp = element;
          if (temp.activeFlag == true) {
            if (
              temp.name == null ||
              temp.name == "" ||
              (temp.secret == null && temp.typeSocial == "line") ||
              (temp.secret == "" && temp.typeSocial == "line") ||
              (temp.token == null && temp.typeSocial == "line") ||
              (temp.token == "" && temp.typeSocial == "line") ||
              (temp.modelDisplayID == null && temp.typeSocial == "snippet") ||
              (temp.secret == null && temp.typeSocial == "facebook") ||
              (temp.secret == "" && temp.typeSocial == "facebook") ||
              (temp.token == null && temp.typeSocial == "facebook") ||
              (temp.token == "" && temp.typeSocial == "facebook") ||
              (temp.pageID == null && temp.typeSocial == "facebook") ||
              (temp.pageID == "" && temp.typeSocial == "facebook") ||
              (temp.secret == null && temp.typeSocial == "instagram") ||
              (temp.secret == "" && temp.typeSocial == "instagram") ||
              (temp.token == null && temp.typeSocial == "instagram") ||
              (temp.token == "" && temp.typeSocial == "instagram") ||
              (temp.pageID == null && temp.typeSocial == "instagram") ||
              (temp.pageID == "" && temp.typeSocial == "instagram")
            ) {
              return false;
            }
          }
        }
        return true;
      },
    
      // Comprehensive email verification validation for all platforms
      ValidateAllEmailVerification() {
        const allLists = [
          { name: 'LINE', data: this.setupList },
          { name: 'Teams', data: this.setupListMS },
          { name: 'Snippet', data: this.setupListSnippet },
          { name: 'Facebook', data: this.setupListFacebook },
          { name: 'Instagram', data: this.setupListInstagram }
        ];
    
        for (const list of allLists) {
          for (let i = 0; i < list.data.length; i++) {
            const item = list.data[i];
            if (item.activeFlag && item.emailVerification) {
              if (!this.ValidateEmailVerificationContacts(item)) {
                const configName = item.name || `Configuration #${i + 1}`;
                return {
                  isValid: false,
                  message: `${list.name} "${configName}": Email verification is enabled but no domains or emails are configured. Please add at least one domain or email to the allowed list.`
                };
              }
            }
          }
        }
    
        return { isValid: true };
      },
    
      // Check if email verification contacts are valid
      ValidateEmailVerificationContacts(item) {
        // Get active domains and emails (exclude those marked as inactive)
        const activeDomains = (item.domains || []).filter(domain => domain.activeFlag !== false);
        const activeEmails = (item.emails || []).filter(email => email.activeFlag !== false);
        
        // Must have at least one domain OR one email
        return activeDomains.length > 0 || activeEmails.length > 0;
      },
  Update() {
  try {
    let self = this;
    self.dialog = true;

    if (!this.validateNameLength()) {
      self.$swal.fire({
        icon: "warning",
        title: self.$t("warning"),
        text: "Name must be less than 100 characters",
        showConfirmButton: false,
        timer: 2000,
      });
      self.dialog = false;
      return;
    }

    // Check basic validation first
    const basicValidationResults = {
      line: self.ValidateBasicFields(self.setupList),
      teams: self.ValidateBasicFields(self.setupListMS),
      snippet: self.ValidateBasicFields(self.setupListSnippet),
      facebook: self.ValidateBasicFields(self.setupListFacebook),
      instagram: self.ValidateBasicFields(self.setupListInstagram)
    };

    const failedBasicValidation = Object.keys(basicValidationResults).find(key => !basicValidationResults[key]);
    if (failedBasicValidation) {
      self.$swal.fire({
        icon: "warning",
        title: self.$t("warning"),
        text: self.$t("warningFillAll"),
        showConfirmButton: false,
        timer: 2000,
      });
      self.dialog = false;
      return;
    }

    // Check email verification validation
    const emailVerificationResult = self.ValidateAllEmailVerification();
    if (!emailVerificationResult.isValid) {
      self.$swal.fire({
        icon: "warning",
        title: self.$t("warning"),
        text: emailVerificationResult.message,
        showConfirmButton: false,
        timer: 3000,
      });
      self.dialog = false;
      return;
    }
    
    if (!self.ValidateSpecialCharacters(self.setupListMS)) {
      self.$swal.fire({
        icon: "warning",
        title: self.$t("warning"),
        text: self.$t("warningSpecialCharacters"),
        showConfirmButton: false,
        timer: 2000,
      });
      self.dialog = false;
      return;
    }

    // CREATE A COPY FOR API CALL - DON'T MODIFY ORIGINAL ARRAYS
    let allSetupItems = [
      ...self.setupList,
      ...self.setupListMS,
      ...self.setupListSnippet,
      ...self.setupListFacebook,
      ...self.setupListInstagram
    ];

    // Normalize and add verified contacts to each item
    allSetupItems = allSetupItems.map(item => {
      const normalizedItem = self.normalizeItemProperties(item);

      if (normalizedItem.emailVerification) {
        normalizedItem.verifiedContacts = self.buildVerifiedContacts(normalizedItem);
      }
      return normalizedItem;
    });

    self.$call.UpdateSocial(
      allSetupItems,
      (dataResponse) => {
        if (dataResponse.status == 0) {
          let msgSuccess = "✔ " + dataResponse.message;
          self.$swal.fire({
            title: msgSuccess,
            showConfirmButton: false,
            timer: 1500,
            position: 'top',
            customClass: {
              popup: 'success-banner',
              title: 'success-banner-title'
            },
          });
          self.GetGeneral();
        } else if (dataResponse.status == 3) {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("warningDuplicateDomain"),
            showConfirmButton: false,
            timer: 2000,
          });
          self.dialog = false;
        } else {
          self.dialog = false;
        }
      },
      (errorResource) => {
        self.dialog = false;
        console.error(errorResource);
      }
    );
  } catch (error) {
    this.LogTrace(error, "UpdateUser");
  }
},
    UpdateLineGeneral() {
      try {
        let self = this;
        self.dialog = true;
        self.MapSetupList(self.setupListGeneral, true);
        self.$call.GetSetupUpdate(
          self.setupListGeneral,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = "✔ " +
                dataResponse.message;
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
              // self.$swal.fire({
              //   icon: "success",
              //   title: dataResponse.message,
              //   showConfirmButton: false,
              //   timer: 1500,
              // });
              self.GetGeneral();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "UpdateUser");
      }
    },
    Add(type) {
      let self = this;
      let temp = {
        socialID: 0,
        name: null,
        secret: null,
        token: null,
        typeSocial: type,
        groupModelID: null,
        createDate: new Date(),
        createBy: null,
        activeFlag: true,
        modelDisplayID: null,
        // Initialize domain/email verification properties
        emailVerification: false,
        domains: [],
        emails: [],
        selectedDomains: [],
        selectedEmails: [],
        showSuggestion: false,
        showEmailSuggestion: false,
        searchDomains: '',
        searchEmails: '',
      };
      if (type == "line") {
        self.setupList.push(temp);
      } else if (type == "ms") {
        temp = {
          socialID: 0,
          name: null,
          secret: null,
          token: null,
          typeSocial: type,
          groupModelID: null,
          modelQuickGroupID: null,
          createDate: new Date(),
          createBy: null,
          activeFlag: true,
          modelDisplayID: null,
          shortcutMenuGroupID: null,
        };

        self.setupListMS.push(temp);
      } else if (type == "snippet") {
        temp = {
          socialID: 0,
          name: null,
          secret: null,
          token: null,
          typeSocial: type,
          groupModelID: null,
          modelQuickGroupID: null,
          createDate: new Date(),
          createBy: null,
          activeFlag: true,
          modelDisplayID: null,
          link: null,
        };
        self.setupListSnippet.push(temp);
      } else if (type == "facebook") {
        temp = {
          socialID: 0,
          name: null,
          secret: null,
          token: null,
          typeSocial: type,
          groupModelID: null,
          modelQuickGroupID: null,
          createDate: new Date(),
          createBy: null,
          activeFlag: true,
          modelDisplayID: null,
          apI_Version: null,
          pageID: null,
        };

        self.setupListFacebook.push(temp);
      } else if (type == "instagram") {
        temp = {
          socialID: 0,
          name: null,
          secret: null,
          token: null,
          typeSocial: type,
          groupModelID: null,
          modelQuickGroupID: null,
          createDate: new Date(),
          createBy: null,
          activeFlag: true,
          modelDisplayID: null,
          apI_Version: null,
          pageID: null,
        };

        self.setupListInstagram.push(temp);
      }
    },
    cancelDeleteConfig() {
      this.dialog_delete_Config = false;
      this.deleteItem = null;
      this.deleteType = '';
      this.deleteIndex = -1;
    },
    Delete(source, index) {
      this.deleteItem = source;
      this.deleteIndex = index;
      this.dialog_delete_Config = true;
    },
    confirmDeleteConfig() {
      let self = this;
      let source = this.deleteItem;
      let index = this.deleteIndex;
      source.activeFlag = false;
      if (source.socialID == 0) {
        if (source.typeSocial == "line") {
          self.setupList.splice(index, 1);
        } else if (source.typeSocial == "ms") {
          self.setupListMS.splice(index, 1);
        } else if (source.typeSocial == "snippet") {
          self.setupListSnippet.splice(index, 1);
        } else if (source.typeSocial == "facebook") {
          self.setupListFacebook.splice(index, 1);
        } else if (source.typeSocial == "instagram") {
          self.setupListInstagram.splice(index, 1);
        }
      }
      self.dialog_delete_Config = false;
    },
    Validate(data) {
      for (const element of data) {
        let temp = element;
        if (temp.activeFlag == true) {
          if (
            temp.name == null ||
            temp.name == "" ||
            (temp.secret == null && temp.typeSocial == "line") ||
            (temp.secret == "" && temp.typeSocial == "line") ||
            (temp.token == null && temp.typeSocial == "line") ||
            (temp.token == "" && temp.typeSocial == "line") ||
            (temp.modelDisplayID == null && temp.typeSocial == "snippet") ||
            (temp.secret == null && temp.typeSocial == "facebook") ||
            (temp.secret == "" && temp.typeSocial == "facebook") ||
            (temp.token == null && temp.typeSocial == "facebook") ||
            (temp.token == "" && temp.typeSocial == "facebook") ||
            (temp.pageID == null && temp.typeSocial == "facebook") ||
            (temp.pageID == "" && temp.typeSocial == "facebook") ||
            (temp.secret == null && temp.typeSocial == "instagram") ||
            (temp.secret == "" && temp.typeSocial == "instagram") ||
            (temp.token == null && temp.typeSocial == "instagram") ||
            (temp.token == "" && temp.typeSocial == "instagram") ||
            (temp.pageID == null && temp.typeSocial == "instagram") ||
            (temp.pageID == "" && temp.typeSocial == "instagram")
          ) {
            return false;
          }
          // NEW: Email verification validation
          if (temp.emailVerification) {
            if (!this.ValidateEmailVerificationContacts(temp)) {
              return false;
            }
          }
        }
      }
      return true;
    },
    // NEW: Validation method for email verification contacts
    ValidateEmailVerificationContacts(item) {
      // Get active domains and emails
      const activeDomains = (item.domains || []).filter(domain => domain.activeFlag !== false);
      const activeEmails = (item.emails || []).filter(email => email.activeFlag !== false);
      
      // Must have at least one domain OR one email
      return activeDomains.length > 0 || activeEmails.length > 0;
    },
    ValidateSpecialCharacters(data) {
      let self = this;
      for (const element of data) {
        let temp = element;
        if (self.checkSpecialCharacters(temp.name)) {
          return false;
        }
      }
      return true;
    },
    specialCharacters: function (evt) {
      evt = evt || window.event;
      if (this.specialCharacter.test(evt.key)) {
        evt.preventDefault();
      }
    },
    specialCharactersDomain: function (evt) {
      evt = evt || window.event;
      if (this.specialCharacterDomain.test(evt.key)) {
        evt.preventDefault();
      }
    },
    checkSpecialCharacters: function (text) {
      return this.specialCharacter.test(text);
    },
    specialCharactersOnPaste(evt) {
      let clipboardData = evt.clipboardData || window.clipboardData;
      let pastedData = clipboardData.getData("Text");

      if (this.specialCharacter.test(pastedData)) {
        evt.preventDefault();
        this.$swal.fire({
          icon: "warning",
          title: this.$t("warning"),
          text: this.$t("warningSpecialCharacters"),
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    ClipboardAPIKey(index) {
      let text = this.setupLinkMS[index];
      navigator.clipboard.writeText(text);
    },
    ClipboardScriptSnippet(index) {
      let text = this.setupListSnippet[index].link;
      navigator.clipboard.writeText(text);
    },
    async GetModel() {
      let self = this;
      await self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModel = dataResponse.data;
          } else {
            self.listDDModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    processVerifiedContacts(data) {
      // Process each item in the data array
      data.forEach((originalItem, index) => {
      const item = this.normalizeItemProperties(originalItem);
      data[index] = item;

      item.domains = [];
      item.emails = [];
      
      if (!item.selectedDomains) item.selectedDomains = [];
      if (!item.selectedEmails) item.selectedEmails = [];
      if (item.showSuggestion === undefined) item.showSuggestion = false;
      if (item.showEmailSuggestion === undefined) item.showEmailSuggestion = false;
      if (!item.searchDomains) item.searchDomains = '';
      if (!item.searchEmails) item.searchEmails = '';

      const verifiedContacts = item.verifiedContacts || item.VerifiedContacts || [];
      if (verifiedContacts && Array.isArray(verifiedContacts)) {
        verifiedContacts.forEach(contact => {
          const isActive = contact.activeFlag !== undefined ? contact.activeFlag : contact.ActiveFlag;
          if (isActive) {
            const contactType = contact.contactType || contact.ContactType;
            const contactValue = contact.contactValue || contact.ContactValue;
            const contactID = contact.contactID || contact.ContactID;

            if (contactType === 'Domain') {
              const domainData = {
                contactID: contactID || 0,
                contactValue: contactValue,
                activeFlag: true // Initialize as active
              };
              if (!item.domains.find(d => d.contactValue === contactValue)) {
                item.domains.push(domainData);
              }
            } else if (contactType === 'Email') {
              const emailData = {
                contactID: contactID || 0,
                contactValue: contactValue,
                activeFlag: true // Initialize as active
              };
              if (!item.emails.find(e => e.contactValue === contactValue)) {
                item.emails.push(emailData);
              }
            }
          }
        });
      }
    });
    },

    buildVerifiedContacts(item) {
      const verifiedContacts = [];

    // Add domains (including those marked for deletion)
    if (item.domains && Array.isArray(item.domains)) {
      item.domains.forEach(domainData => {
        verifiedContacts.push({
          contactID: domainData.contactID || 0,
          contactType: 'Domain',
          contactValue: domainData.contactValue,
          activeFlag: domainData.activeFlag !== false, // Will be false if marked for deletion
          createBy: domainData.createBy || 'admin',
          createDate: domainData.createDate || new Date()
        });
      });
    }

    // Add emails (including those marked for deletion)
    if (item.emails && Array.isArray(item.emails)) {
      item.emails.forEach(emailData => {
        verifiedContacts.push({
          contactID: emailData.contactID || 0,
          contactType: 'Email',
          contactValue: emailData.contactValue,
          activeFlag: emailData.activeFlag !== false, // Will be false if marked for deletion
          createBy: emailData.createBy || 'admin',
          createDate: emailData.createDate || new Date()
        });
      });
    }

    return verifiedContacts;
    },

    // Ensure consistent property naming for API compatibility
    normalizeItemProperties(item) {
      // Ensure all items have consistent property names that match API expectations
      return {
        socialID: item.socialID || item.SocialID || 0,
        name: item.name || item.Name || null,
        secret: item.secret || item.Secret || null,
        token: item.token || item.Token || null,
        typeSocial: item.typeSocial || item.TypeSocial || null,
        groupModelID: item.groupModelID || item.GroupModelID || null,
        modelQuickGroupID: item.modelQuickGroupID || item.ModelQuickGroupID || null,
        modelDisplayID: item.modelDisplayID || item.ModelDisplayID || null,
        shortcutMenuGroupID: item.shortcutMenuGroupID || item.ShortcutMenuGroupID || null,
        apI_Version: item.apI_Version || item.API_Version || null,
        pageID: item.pageID || item.PageID || null,
        createDate: item.createDate || item.CreateDate || new Date(),
        createBy: item.createBy || item.CreateBy || null,
        lineUserID: item.lineUserID || item.LineUserID || null,
        activeFlag: item.activeFlag !== undefined ? item.activeFlag : (item.ActiveFlag !== undefined ? item.ActiveFlag : true),
        emailVerification: item.emailVerification !== undefined ? item.emailVerification : (item.EmailVerification !== undefined ? item.EmailVerification : false),
        verifiedContacts: item.verifiedContacts || item.VerifiedContacts || [],
        link: item.link || item.Link || null,
        // Preserve domain/email management properties
        domains: item.domains || [],
        emails: item.emails || [],
        selectedDomains: item.selectedDomains || [],
        selectedEmails: item.selectedEmails || [],
        showSuggestion: item.showSuggestion || false,
        showEmailSuggestion: item.showEmailSuggestion || false,
        searchDomains: item.searchDomains || '',
        searchEmails: item.searchEmails || ''
      };
    },

    // Domain validation and management methods
    isValidDomain(domain) {
      if (!domain || typeof domain !== 'string') {
        return false;
      }

      // Basic domain format regex
      const domainRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

      // Check if domain matches the pattern and doesn't start/end with hyphen
      if (!domainRegex.test(domain)) {
        return false;
      }

      // Additional checks
      const parts = domain.split('.');

      // Must have at least one dot (e.g., example.com)
      if (parts.length < 2) {
        return false;
      }

      // Each part should not be empty and not exceed 63 characters
      for (let part of parts) {
        if (part.length === 0 || part.length > 63) {
          return false;
        }
      }

      // Last part (TLD) should not be all numeric
      const tld = parts[parts.length - 1];
      if (/^\d+$/.test(tld)) {
        return false;
      }

      return true;
    },

    validateDomains(item, selectedValues) {
      // Check if any domain is invalid to show suggestion
      const hasInvalidDomain = selectedValues.some(chipItem => {
        const value = typeof chipItem === 'string' ? chipItem : chipItem.value;
        return !this.isValidDomain(value);
      });

      item.showSuggestion = hasInvalidDomain;
    },

    insertDomains(item) {
    const validDomains = item.selectedDomains
      .map(chipItem => typeof chipItem === 'string' ? chipItem : chipItem.value)
      .filter(domain => this.isValidDomain(domain))
      .filter(domain => !item.domains.find(d => d.contactValue === domain)); // Avoid duplicates

    if (validDomains.length > 0) {
      validDomains.forEach(domain => {
        item.domains.push({
          contactID: 0, // New domains don't have contactID yet
          contactValue: domain,
          activeFlag: true // New domains are active
        });
      });

      item.selectedDomains = [];
    } else {
      this.$swal.fire({
        icon: "warning",
        title: this.$t("warning") || "Warning",
        text: "No valid domains to insert or domains already exist",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  },

    editDomain(item, index) {
      this.openEditDomainDialog(item, index);
    },

    deleteDomain(item, index) {
      const domainToDelete = item.domains[index];   
      this.deleteItem = domainToDelete;
      this.deleteType = 'domain';
      this.deleteIndex = index;
      this.currentEditingItem = item;
      this.dialog_delete = true;
    },
    // Email validation and management methods
    isValidEmail(email) {
      if (!email || typeof email !== 'string') {
        return false;
      }

      // Email validation regex
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      // Basic format check
      if (!emailRegex.test(email)) {
        return false;
      }

      // Additional checks
      const parts = email.split('@');
      if (parts.length !== 2) {
        return false;
      }

      const [localPart, domainPart] = parts;

      // Local part validation (before @)
      if (localPart.length === 0 || localPart.length > 64) {
        return false;
      }

      // Domain part validation (after @)
      if (domainPart.length === 0 || domainPart.length > 255) {
        return false;
      }

      // Check for consecutive dots
      if (email.includes('..')) {
        return false;
      }

      // Check for leading/trailing dots in local part
      if (localPart.startsWith('.') || localPart.endsWith('.')) {
        return false;
      }

      return true;
    },

    validateEmails(item, selectedValues) {
      // Check if any email is invalid to show suggestion
      const hasInvalidEmail = selectedValues.some(chipItem => {
        const value = typeof chipItem === 'string' ? chipItem : chipItem.value;
        return !this.isValidEmail(value);
      });

      item.showEmailSuggestion = hasInvalidEmail;
    },

    removeDomainChip(item, chipValue) {
      const index = item.selectedDomains.findIndex(d => {
        const value = typeof d === 'string' ? d : d.value;
        return value === chipValue;
      });

      if (index > -1) {
        item.selectedDomains.splice(index, 1);
        setTimeout(() => this.validateDomains(item, item.selectedDomains), 10);
      }
    },

    removeEmailChip(item, chipValue) {
      const index = item.selectedEmails.findIndex(e => {
        const value = typeof e === 'string' ? e : e.value;
        return value === chipValue;
      });

      if (index > -1) {
        item.selectedEmails.splice(index, 1);
        setTimeout(() => this.validateEmails(item, item.selectedEmails), 10);
      }
    },

    // Filter methods for search functionality
    getFilteredDomains(item) {
    if (!item.domains) return [];

    // Filter out inactive domains
    const activeDomains = item.domains.filter(domain => 
      domain.activeFlag !== false
    );

    const searchTerm = (item.searchDomains || '').toLowerCase().trim();
    if (!searchTerm) return activeDomains;

    return activeDomains.filter(domain => {
      const domainValue = (domain.contactValue || domain || '').toLowerCase();
      return domainValue.includes(searchTerm);
    });
  },

  getFilteredEmails(item) {
    if (!item.emails) return [];

    // Filter out inactive emails
    const activeEmails = item.emails.filter(email => 
      email.activeFlag !== false
    );

    const searchTerm = (item.searchEmails || '').toLowerCase().trim();
    if (!searchTerm) return activeEmails;

    return activeEmails.filter(email => {
      const emailValue = (email.contactValue || email || '').toLowerCase();
      return emailValue.includes(searchTerm);
    });
  },

    // Get filtered index for edit/delete operations
    getOriginalDomainIndex(item, filteredIndex) {
      const filteredDomains = this.getFilteredDomains(item);
      const targetDomain = filteredDomains[filteredIndex];
      return item.domains.findIndex(domain => {
        const domainValue = domain.contactValue || domain;
        const targetValue = targetDomain.contactValue || targetDomain;
        return domainValue === targetValue;
      });
    },

    getOriginalEmailIndex(item, filteredIndex) {
      const filteredEmails = this.getFilteredEmails(item);
      const targetEmail = filteredEmails[filteredIndex];
      return item.emails.findIndex(email => {
        const emailValue = email.contactValue || email;
        const targetValue = targetEmail.contactValue || targetEmail;
        return emailValue === targetValue;
      });
    },

    insertEmails(item) {
    const validEmails = item.selectedEmails
      .map(chipItem => typeof chipItem === 'string' ? chipItem : chipItem.value)
      .filter(email => this.isValidEmail(email))
      .filter(email => !item.emails.find(e => e.contactValue === email)); // Avoid duplicates

    if (validEmails.length > 0) {
      validEmails.forEach(email => {
        item.emails.push({
          contactID: 0, // New emails don't have contactID yet
          contactValue: email,
          activeFlag: true // New emails are active
        });
      });

      item.selectedEmails = [];
    } else {
      this.$swal.fire({
        icon: "warning",
        title: this.$t("warning") || "Warning",
        text: "No valid emails to insert or emails already exist",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  },

    editEmail(item, index) {
      this.openEditEmailDialog(item, index);
    },

    deleteEmail(item, index) {
      const emailToDelete = item.emails[index];
      
      this.deleteItem = emailToDelete;
      this.deleteType = 'email';
      this.deleteIndex = index;
      this.currentEditingItem = item;
      this.dialog_delete = true;
    },

    deleteAllDomains(item) {
      if (!item.domains || item.domains.length === 0) {
        this.$swal.fire({
          icon: "info",
          title: "No Domains",
          text: "There are no domains to delete",
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }

      this.deleteItem = `all ${item.domains.length} domains`;
      this.deleteType = 'domain-all';
      this.deleteIndex = -1;
      this.currentEditingItem = item;
      this.dialog_delete = true;
    },

    deleteAllEmails(item) {
      if (!item.emails || item.emails.length === 0) {
        this.$swal.fire({
          icon: "info",
          title: "No Emails",
          text: "There are no emails to delete",
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }

      this.deleteItem = `all ${item.emails.length} emails`;
      this.deleteType = 'email-all';
      this.deleteIndex = -1;
      this.currentEditingItem = item;
      this.dialog_delete = true;
    },

    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
      this.deleteType = '';
      this.deleteIndex = -1;
    },

    confirmDelete() {
      switch (this.deleteType) {
        case 'domain':
          this.performDeleteDomain();
          break;
        case 'email':
          this.performDeleteEmail();
          break;
        case 'domain-all':
          this.performDeleteAllDomains();
          break;
        case 'email-all':
          this.performDeleteAllEmails();
          break;
      }
      this.cancelDelete(); // Reset dialog state
    },

    performDeleteDomain() {
    if (this.currentEditingItem && this.deleteIndex !== -1) {
      const domainToDelete = this.currentEditingItem.domains[this.deleteIndex];
      
      // If the domain has a contactID (exists in database), mark it for deletion
      if (domainToDelete.contactID && domainToDelete.contactID > 0) {
        // Mark as inactive instead of removing from array
        domainToDelete.activeFlag = false;
      } else {
        // If it's a new domain (contactID is 0 or null), remove from array
        this.currentEditingItem.domains.splice(this.deleteIndex, 1);
      }
    }
  },
    performDeleteEmail() {
    if (this.currentEditingItem && this.deleteIndex !== -1) {
      const emailToDelete = this.currentEditingItem.emails[this.deleteIndex];
      
      // If the email has a contactID (exists in database), mark it for deletion
      if (emailToDelete.contactID && emailToDelete.contactID > 0) {
        // Mark as inactive instead of removing from array
        emailToDelete.activeFlag = false;
      } else {
        // If it's a new email (contactID is 0 or null), remove from array
        this.currentEditingItem.emails.splice(this.deleteIndex, 1);
      }
    }
  },
    performDeleteAllDomains() {
    if (this.currentEditingItem) {
      // Mark all existing domains as inactive, remove new ones
      this.currentEditingItem.domains.forEach(domain => {
        if (domain.contactID && domain.contactID > 0) {
          domain.activeFlag = false;
        }
      });
      
      // Remove only new domains (those without contactID)
      this.currentEditingItem.domains = this.currentEditingItem.domains.filter(domain => 
        domain.contactID && domain.contactID > 0
      );
    }
  },
    performDeleteAllEmails() {
    if (this.currentEditingItem) {
      // Mark all existing emails as inactive, remove new ones
      this.currentEditingItem.emails.forEach(email => {
        if (email.contactID && email.contactID > 0) {
          email.activeFlag = false;
        }
      });
      
      // Remove only new emails (those without contactID)
      this.currentEditingItem.emails = this.currentEditingItem.emails.filter(email => 
        email.contactID && email.contactID > 0
      );
    }
  },

    // Edit dialog methods
    openEditDomainDialog(item, index) {
      this.currentEditingConfig = item;
      this.editIndex = index;
      this.editType = 'domain';
      this.editValue = item.domains[index].contactValue || item.domains[index];
      this.dialog_edit = true;
    },

    openEditEmailDialog(item, index) {
      this.currentEditingConfig = item;
      this.editIndex = index;
      this.editType = 'email';
      this.editValue = item.emails[index].contactValue || item.emails[index];
      this.dialog_edit = true;
    },

    cancelEdit() {
      this.dialog_edit = false;
      this.editValue = '';
      this.editType = '';
      this.editIndex = -1;
      this.currentEditingConfig = null;
    },

    confirmEdit() {
      if (!this.isEditValueValid) return;

      const trimmedValue = this.editValue.trim();

      if (this.editType === 'domain') {
        this.performEditDomain(trimmedValue);
      } else if (this.editType === 'email') {
        this.performEditEmail(trimmedValue);
      }

      this.cancelEdit();
    },

    performEditDomain(newValue) {
      if (this.currentEditingConfig && this.editIndex !== -1) {
        // Check if domain already exists
        const existingDomain = this.currentEditingConfig.domains.find((d, idx) => {
          const domainValue = d.contactValue || d;
          return idx !== this.editIndex && domainValue === newValue;
        });

        if (existingDomain) {
          this.$swal.fire({
            icon: "warning",
            title: "Duplicate Domain",
            text: "This domain already exists in the list",
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }

        // Update the domain
        if (typeof this.currentEditingConfig.domains[this.editIndex] === 'object') {
          this.currentEditingConfig.domains[this.editIndex].contactValue = newValue;
        } else {
          this.currentEditingConfig.domains[this.editIndex] = newValue;
        }
      }
    },

    performEditEmail(newValue) {
      if (this.currentEditingConfig && this.editIndex !== -1) {
        // Check if email already exists
        const existingEmail = this.currentEditingConfig.emails.find((e, idx) => {
          const emailValue = e.contactValue || e;
          return idx !== this.editIndex && emailValue === newValue;
        });

        if (existingEmail) {
          this.$swal.fire({
            icon: "warning",
            title: "Duplicate Email",
            text: "This email already exists in the list",
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }

        // Update the email
        if (typeof this.currentEditingConfig.emails[this.editIndex] === 'object') {
          this.currentEditingConfig.emails[this.editIndex].contactValue = newValue;
        } else {
          this.currentEditingConfig.emails[this.editIndex] = newValue;
        }
      }
    },

    onExpandChange(index) {
      this.expandedPanel = this.expandedPanel === index ? null : index;
    },
  },
};
</script>
<style scoped>
/* =================== BASE STYLES =================== */
.setup-social {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
}

.title {
  color: white;
}

.config-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* =================== STICKY TABS STYLES =================== */
.sticky-tabs-container {
  position: sticky;
  top: 0;
  z-index: 100;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: -24px -24px 24px -24px;
  padding: 0 24px;
}

.sticky-tabs {
  background: white !important;
}

/* =================== SAVE BUTTON STYLES =================== */
.save-action-button {
  min-width: 200px !important;
  height: 48px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.save-action-button:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 16px rgba(24, 83, 192, 0.35) !important;
}

.save-action-button:active {
  transform: translateY(0) !important;
}

.save-action-button .v-btn__prepend {
  margin-right: 8px;
}

.sticky-save-btn {
  position: fixed;
  top: 160px;
  right: 30px;
  z-index: 1000;
  max-width: 800px;
  box-shadow: 0px 6px 12px rgba(8, 36, 87, 0.4) !important;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  animation: slideInFromRight 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.sticky-save-btn:hover {
  transform: translateX(-5px) scale(1.02);
  box-shadow: 0px 12px 20px rgba(14, 69, 133, 0.5) !important;
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    visibility: hidden;
    transform: translateX(100px);
  }

  to {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }
}

/* =================== TABS STYLES =================== */
.platform-tabs-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.modern-tabs {
  --v-tabs-height: 90px;
}

.modern-tabs :deep(.v-tabs) {
  height: 50px !important;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
}

.modern-tabs :deep(.v-tabs-slider) {
  transition: transform 0.15s ease-out !important;
}

.platform-tab {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  min-height: 64px !important;
  padding: 5px 24px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.tab-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: column;
}

.tab-text {
  font-size: 0.875rem;
  font-weight: 600;
}

/* Tab Active Colors */
.tab-line :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%) !important;
  color: #15803d !important;
  transition: all 0.1s ease-out !important;
}

.tab-teams :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%) !important;
  color: #7c3aed !important;
  transition: all 0.1s ease-out !important;
}

.tab-facebook :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%) !important;
  color: #2563eb !important;
  transition: all 0.1s ease-out !important;
}

.tab-instagram :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%) !important;
  color: #db2777 !important;
  transition: all 0.1s ease-out !important;
}

.tab-snippet :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #fed7aa 0%, #fdba74 100%) !important;
  color: #ea580c !important;
  transition: all 0.1s ease-out !important;
}

/* =================== PLATFORM CONTENT =================== */
.platform-window {
  min-height: 600px;
}

.platform-content-wrapper {
  padding: 32px;
}

.platform-header-info {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 16px;
  margin-bottom: 32px;
  border: 1px solid rgba(226, 232, 240, 0.8);
}

.platform-icon-large {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.platform-details {
  flex: 1;
}

.platform-details h2 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.platform-details p {
  color: #6b7280;
  font-size: 1rem;
  margin: 0;
}

.platform-stats {
  display: flex;
  gap: 24px;
}

.stat-item {
  text-align: center;
  padding: 16px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  min-width: 80px;
}

.stat-number {
  display: block;
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
}

.stat-label {
  display: block;
  font-size: 0.75rem;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 4px;
}

.stat-label-1 {
  display: block;
  font-size: 0.75rem;
  color: #6b7280;
  letter-spacing: 0.5px;
  margin-top: 4px;
}

/* =================== PLATFORM GRADIENTS =================== */
.line-gradient {
  background: linear-gradient(135deg, #10b951 0%, #059629 100%);
}

.teams-gradient {
  background: linear-gradient(135deg, #665cf6 0%, #3a64ed 100%);
}

.facebook-gradient {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

.instagram-gradient {
  background: linear-gradient(45deg, #ffe714 10%, #f01859 50%, #9f00e9 100%);
}

.snippet-gradient {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
}

/* =================== CONFIG CARDS =================== */
.configurations-grid {
  min-height: 400px;
}

.config-cards-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.config-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 2px solid transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  animation: slideInUp 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.config-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
}

.config-card:nth-child(2) {
  animation-delay: 0.1s;
}

.config-card:nth-child(3) {
  animation-delay: 0.2s;
}

.config-card:nth-child(4) {
  animation-delay: 0.3s;
}

.config-card:nth-child(5) {
  animation-delay: 0.3s;
}

.config-card:nth-child(6) {
  animation-delay: 0.3s;
}

/* Platform Specific Card Colors */
.line-card {
  border-top: 4px solid #24b910;
}

.line-card:hover {
  border-color: #1eb910;
  box-shadow: 0 12px 30px rgba(16, 185, 30, 0.1);
}

.teams-card {
  border-top: 4px solid #8b5cf6;
}

.teams-card:hover {
  border-color: #8b5cf6;
  box-shadow: 0 12px 30px rgba(139, 92, 246, 0.15);
}

.facebook-card {
  border-top: 4px solid #3b82f6;
}

.facebook-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 12px 30px rgba(59, 130, 246, 0.15);
}

.instagram-card {
  border-top: 4px solid #ec4899;
}

.instagram-card:hover {
  border-color: #ec4899;
  box-shadow: 0 12px 30px rgba(236, 72, 153, 0.15);
}

.snippet-card {
  border-top: 4px solid #f97316;
}

.snippet-card:hover {
  border-color: #f97316;
  box-shadow: 0 12px 30px rgba(249, 115, 22, 0.15);
}

.config-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px 24px;
  border-bottom: 1px solid #f1f5f9;
}

.config-badge {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  color: #475569;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8125rem;
  font-weight: 600;
}

.teams-badge {
  background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%);
  color: #7c3aed;
}

.facebook-badge {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #2563eb;
}

.instagram-badge {
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
  color: #db2777;
}

.snippet-badge {
  background: linear-gradient(135deg, #fed7aa 0%, #fdba74 100%);
  color: #ea580c;
}

.delete-icon-btn {
  transition: all 0.3s ease;
}

.delete-icon-btn:hover {
  background: rgba(239, 68, 68, 0.1) !important;
  transform: scale(1.1);
}

.config-card-body {
  padding: 24px;
}

/* =================== FORM SECTIONS =================== */
.form-section {
  margin-bottom: 32px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f5f9;
}

/* =================== MODERN INPUT STYLES =================== */
.modern-field :deep(.v-field) {
  background: #fafbfc;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.modern-field :deep(.v-field:hover) {
  background: #f8fafc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.modern-field :deep(.v-field--focused) {
  background: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
}

/* .secure-field :deep(.v-field) {
  background: linear-gradient(135deg, #fef7ed 0%, #ffffff 100%);
} */

/* =================== ADD CONFIG CARD =================== */
.add-config-card {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.add-config-card:hover {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-color: #94a3b8;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
}

.add-card-content {
  text-align: center;
  padding: 32px;
}

.add-card-content h4 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
}

.add-card-content p {
  color: #6b7280;
  margin: 0;
}

/* =================== EMPTY STATE =================== */
.empty-state-card {
  background: white;
  border-radius: 16px;
  padding: 64px 32px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
}

.empty-icon {
  margin-bottom: 24px;
}

.empty-state-card h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
}

.empty-state-card p {
  color: #6b7280;
  font-size: 1rem;
  margin: 0 0 32px 0;
}

.config-count-chip {
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  height: 24px !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
}

.config-count-chip:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;
}

/* Platform Specific Chip Styles */
.chip-line {
  background: linear-gradient(135deg, #10b951 0%, #059629 100%) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.chip-teams {
  background: linear-gradient(135deg, #665cf6 0%, #3a64ed 100%) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.chip-facebook {
  background: linear-gradient(135deg, #3b82f6, #2563eb) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.chip-instagram {
  background: linear-gradient(120deg, #f01872 0%, #db2754 100%) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.chip-snippet {
  background: linear-gradient(135deg, #f97316, #ea580c) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

/* Tab positioning adjustment for absolute positioned chip */
.platform-tab {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  min-height: 64px !important;
  padding: 5px 24px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important; /* เพื่อให้ chip อยู่ในตำแหน่งที่ถูกต้อง */
}

/* =================== ANIMATIONS =================== */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* =================== RESPONSIVE DESIGN =================== */
@media (max-width: 960px) {
  .sticky-save-btn {
    width: 200px;
    right: 20px;
    top: 120px;
  }

  .platform-header-info {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }

  .platform-stats {
    justify-content: center;
  }

  .config-cards-container {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .config-cards-container {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .platform-tabs-container :deep(.v-tabs) {
    overflow-x: auto;
  }

  .platform-content-wrapper {
    padding: 16px;
  }

  .tab-content {
    flex-direction: row;
  }

  .tab-text {
    display: none;
  }
}

@media (max-width: 600px) {
  .sticky-save-btn {
    width: 180px;
    right: 15px;
    top: 100px;
    font-size: 0.9rem !important;
  }

  .save-action-button {
    min-width: 180px !important;
    height: 44px !important;
    font-size: 0.9rem !important;
  }
}

/* =================== OVERLAY =================== */
.v-overlay--active ~ .setup-container .sticky-save-btn {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

/* =================== COMPACT TEXT BUTTON STYLES =================== */
.compact-text-btn {
  min-width: 120px !important;
  height: 36px !important;
  font-size: 0.85rem !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.025em !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.compact-text-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
}

.compact-text-btn:active {
  transform: translateY(0) !important;
  transition: all 0.1s ease !important;
}

/* Platform-specific compact text variants */
.compact-text-btn.line-btn {
  background-color: #06c226 !important;
  color: white !important;
  border-color: #05a820 !important;
}

.compact-text-btn.line-btn:hover {
  background-color: #0ece2e !important;
  box-shadow: 0 2px 6px rgba(16, 185, 38, 0.25) !important;
}

.compact-text-btn.teams-btn {
  background-color: #403df1 !important;
  color: white !important;
  border-color: #613aed !important;
}

.compact-text-btn.teams-btn:hover {
  background-color: #2f3cfa !important;
  box-shadow: 0 2px 6px rgba(92, 95, 246, 0.25) !important;
}

.compact-text-btn.facebook-btn {
  background-color: #3b82f6 !important;
  color: white !important;
  border-color: #2563eb !important;
}

.compact-text-btn.facebook-btn:hover {
  background-color: #2563eb !important;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.25) !important;
}

.compact-text-btn.instagram-btn {
  background-color: #ec4899 !important;
  color: white !important;
  border-color: #db2777 !important;
}

.compact-text-btn.instagram-btn:hover {
  background-color: #db2777 !important;
  box-shadow: 0 2px 6px rgba(236, 72, 153, 0.25) !important;
}

.compact-text-btn.snippet-btn {
  background-color: #f97316 !important;
  color: white !important;
  border-color: #ea580c !important;
}

.compact-text-btn.snippet-btn:hover {
  background-color: #ea580c !important;
  box-shadow: 0 2px 6px rgba(249, 115, 22, 0.25) !important;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .compact-text-btn {
    min-width: 100px !important;
    height: 32px !important;
    font-size: 0.8rem !important;
  }

  .compact-text-btn .v-icon {
    font-size: 16px !important;
  }
}

/* Extra compact variant */
.compact-text-btn.extra-compact {
  min-width: 90px !important;
  height: 30px !important;
  font-size: 0.75rem !important;
  padding: 0 12px !important;
}

.compact-text-btn.extra-compact .v-icon {
  font-size: 14px !important;
}

.outlined-red-btn {
  border-radius: 12px !important;
  width: 180px;
  height: 40px;
  color: #C32E0E !important;
  font-size: 13px !important;
  background-color: transparent !important;
  border: 1px solid #C32E0E !important;
  text-transform: none !important;
}

.save-action-button-small {
  min-width: 180px !important;
  height: 40px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 12px !important;
}

.accordion-custom {
  background: linear-gradient(90deg, #FFF2F2 0%, #FFDED8 100%);
  border-radius: 12px;
  border: 1px solid #f5c2c2;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-bottom: 10px;
}

.accordion-title {
  padding: 12px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
  border-bottom: 1px solid #f1c7c7;
  border-radius: 12px 12px 0 0;
}


.accordion-open {
  border-bottom: 1px solid #f1c7c7;
  border-radius: 12px;
}

/* Inner content (white area) */
.accordion-content {
  background-color: white;
  border-radius: 0 0 12px 12px;
  transition: all 0.3s ease;
}

.accordion-inner-card {
  background-color: transparent;
  box-shadow: none;
}

.config-card-text {
  background: #ffffff;
  border: 1px solid #f1caca;
  border-radius: 16px;
  padding: 24px;
}

.section {
  margin-bottom: 16px;
}

.section-header {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #333;
}

.section-title-1 {
  font-size: 15px;
  font-weight: 600;
}

.switch-hint {
  font-size: 13px;
  color: #777;
  margin-top: -4px;
  margin-left: 36px;
}

.publication-toggle {
  margin: 0 4px;
}

.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  border-radius: 999px;
  border: 2px solid transparent;
  background-color: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  border: 2px solid transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border-color: #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border-color: #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  border-color: #bdbdbd;
  width: 30px;
  height: 30px;
}

.option-card {
  padding: 5px 16px;
  border-radius: 10px !important;
  background-color: #EDEDED;
  height: 50px !important;
  border: 1px solid transparent;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
}

.option-header {
  max-width: calc(100% - 50px);
}

/* Container */
.allowed-domain-container {
  background-color: transparent;
}

/* Combobox */
:deep .allowed-domain-combobox .v-field {
  border-radius: 18px;
}
/* Insert button */
.allowed-domain-insert-btn {
  font-weight: 500;
  max-width: 180px;
}

/* Header */
.allowed-domain-title {
  color: #1a1a1a;
}

/* Search bar */
.allowed-domain-search-field {
  max-width: 350px;
}

/* Table */
.allowed-domain-table {
  background-color: #fff;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  margin-top: 10px;
}

/* Table headers */
.allowed-domain-th {
  background-color: #ffeaea;
  color: #171717;
  font-weight: bold!important;
  padding: 10px 16px;
}

/* Table rows */
.allowed-domain-tr:nth-child(even) {
  background-color: #fffafc;
}

.allowed-domain-td {
  padding: 10px 16px;
  border-top: 1px solid #eee;
}

/* Buttons inside table */
.allowed-domain-edit-btn,
.allowed-domain-delete-btn {
  min-width: 0 !important;
}

:deep(.v-table tbody tr:hover) {
  background-color: #F8F9FA !important;
}

:deep(.v-table .v-table__wrapper > table > tbody > tr > td) {
  border: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}

:deep(.v-table .v-table__wrapper > table > thead > tr > th) {
  border: none !important;
}

:deep(.v-table .v-table__wrapper > table > thead > tr th.v-table-column--align-center .v-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}

:deep(.v-table .v-table__wrapper > table > thead > tr th.v-table-column--align-start .v-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}

.allowed-domain-suggestion {
  color: #1a73e8;
  /* Google-style blue */
  font-size: 13px;
  font-weight: 500;
  background-color: #ffffff;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(26, 115, 232, 0.15);
  display: inline-block;
  padding: 4px 10px;
  margin-top: 6px;
  margin-left: 8px;
  transition: all 0.2s ease;
}

/* Custom Delete Dialog Styles */
.delete-dialog-card {
  border-radius: 8px !important;
  padding: 0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden !important;
}

.delete-dialog-header {
  background: linear-gradient(180deg, #ffffff 0%, #fff1f0 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 6px 10px 24px !important;
}

.delete-dialog-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #dc3545 !important;
  margin: 0 !important;
}

.delete-close-icon {
  color: #6c757d !important;
  margin: 0 !important;
}

.delete-close-icon:hover {
  background-color: #f8f9fa !important;
}

.delete-dialog-content {
  font-size: 14px !important;
  color: #212529 !important;
  text-align: left !important;
  padding: 24px !important;
  line-height: 1.6 !important;
  border-bottom: 1px solid #dee2e6 !important;
  margin-bottom: 12px !important;
}

.delete-dialog-actions {
  padding: 0 24px 14px 24px !important;
  justify-content: flex-end !important;
  gap: 12px !important;
}

.delete-cancel-btn {
  background-color: white !important;
  color: #495057 !important;
  border: 1px solid #ced4da !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  box-shadow: none !important;
  height: 40px !important;
  min-width: 90px !important;
}

.delete-cancel-btn:hover {
  background-color: #f8f9fa !important;
  border-color: #adb5bd !important;
}

.delete-confirm-btn {
  background-color: #C30000 !important;
  color: white !important;
  border: none !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  height: 40px !important;
  min-width: 100px !important;
}

.delete-confirm-btn:hover {
  background-color: #c82333 !important;
}

.delete-confirm-btn .v-icon {
  margin-right: 6px;
}

/* Custom Edit Dialog Styles */
.edit-dialog-card {
  border-radius: 8px !important;
  padding: 0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden !important;
}

.edit-dialog-header {
  background: linear-gradient(180deg, #ffffff 0%, #f0f8ff 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 6px 10px 24px !important;
}

.edit-dialog-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #0d6efd !important;
  margin: 0 !important;
}

.edit-close-icon {
  color: #6c757d !important;
  margin: 0 !important;
}

.edit-close-icon:hover {
  background-color: #f8f9fa !important;
}

.edit-dialog-content {
  padding: 24px !important;
  border-bottom: 1px solid #dee2e6 !important;
  margin-bottom: 12px !important;
}

.edit-dialog-actions {
  padding: 0 24px 14px 24px !important;
  justify-content: flex-end !important;
  gap: 12px !important;
}

.edit-cancel-btn {
  background-color: white !important;
  color: #495057 !important;
  border: 1px solid #ced4da !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  box-shadow: none !important;
  height: 40px !important;
  min-width: 90px !important;
}

.edit-cancel-btn:hover {
  background-color: #f8f9fa !important;
  border-color: #adb5bd !important;
}

.edit-confirm-btn {
  background-color: #0d6efd !important;
  color: white !important;
  border: none !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  height: 40px !important;
  min-width: 100px !important;
}

.edit-confirm-btn:hover {
  background-color: #0b5ed7 !important;
}

.edit-confirm-btn:disabled {
  background-color: #6c757d !important;
  opacity: 0.6 !important;
}

.edit-confirm-btn .v-icon {
  margin-right: 6px;
}


.platform-tabs :deep(.v-tabs) {
  height: 50px !important;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
}

.platform-tabs :deep(.v-tabs-slider) {
  transition: transform 0.15s ease-out !important;
}

.platform-tabs {
  --v-tabs-height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 10px 0 14px;
  position: sticky;
  top: 0;
  z-index: 20;
}

.platform-tab {
  text-transform: none;
  font-weight: 800;
  color: #333;
  border-radius: 16px;
  transition: all 0.25s ease;
  background-color: transparent;
}

.platform-tab .tab-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px 20px;
  border-radius: 16px;
  min-width: 210px;
  transition: all 0.25s ease;
}

.platform-tab .tab-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-chip {
  position: absolute;
  top: -4px;
  right: -14px;
  color: #fff !important;
  font-weight: 600;
  border-radius: 8px;
  padding: 0 4px;
  font-size: 10px;
}

.tab-label {
  font-weight: 600;
}

/* Platform colors */
.tab-line.active .tab-inner {
  background-color: #e8f9ef;
  color: #00b900;
}

.tab-teams.active .tab-inner {
  background-color: #f0ebff;
  color: #6159e4;
}

.tab-facebook.active .tab-inner {
  background-color: #edf4ff;
  color: #1877f2;
}

.tab-instagram.active .tab-inner {
  background-color: #fff0f5;
  color: #d62976;
}

.tab-snippet.active .tab-inner {
  background-color: #fff5ec;
  color: #ff7f2a;
}

/* Hover */
.platform-tab:hover .tab-inner {
  background-color: #f8f9fa;
}

.action-divider {
  width: 100%;
  height: 1px;
  background: rgba(0, 0, 0, 0.12);
  margin: 25px 0;
  align-self: center;
  border-radius: 1px;
}

.nodatadiv{
  border-radius: 8px;
    background: #FFF;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.16);
    display: inline-flex;
    padding: 20px;
    justify-content: center;
    align-items: center;
}
.customwidth {
  max-width: 70%!important;
  transition: max-width 0.3s ease;
}
.customwidth-expanded {
  max-width: 100% !important;
  transition: max-width 0.3s ease;
}
</style>